
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4c56"];
var parcelRegister = parcelRequire.register;
parcelRegister("bYKaS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b891d9bad69994b$export$2e2bcd8739ae039; });

var $h3G97 = parcelRequire("h3G97");

var $eNjeQ = parcelRequire("eNjeQ");

var $gOovR = parcelRequire("gOovR");

var $i20Nl = parcelRequire("i20Nl");

var $dBnLY = parcelRequire("dBnLY");

var $VF2pv = parcelRequire("VF2pv");
var $8b891d9bad69994b$var$_excluded = [
    "className",
    "cssModule",
    "tag",
    "size"
];
var $8b891d9bad69994b$var$propTypes = {
    tag: (0, $VF2pv.tagPropType),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($i20Nl))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($i20Nl))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($i20Nl))).object
};
var $8b891d9bad69994b$var$defaultProps = {
    tag: "div"
};
var $8b891d9bad69994b$var$InputGroup = function InputGroup(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, size = props.size, attributes = (0, $eNjeQ.default)(props, $8b891d9bad69994b$var$_excluded);
    var classes = (0, $VF2pv.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($dBnLY)))(className, "input-group", size ? "input-group-" + size : null), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gOovR))).createElement(Tag, (0, $h3G97.default)({}, attributes, {
        className: classes
    }));
};
$8b891d9bad69994b$var$InputGroup.propTypes = $8b891d9bad69994b$var$propTypes;
$8b891d9bad69994b$var$InputGroup.defaultProps = $8b891d9bad69994b$var$defaultProps;
var $8b891d9bad69994b$export$2e2bcd8739ae039 = $8b891d9bad69994b$var$InputGroup;

});

parcelRegister("fHII3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6ed8d87cb828221$export$2e2bcd8739ae039; });

var $5smQ2 = parcelRequire("5smQ2");

var $h3G97 = parcelRequire("h3G97");

var $gOovR = parcelRequire("gOovR");

var $iyuie = parcelRequire("iyuie");

var $jodTf = parcelRequire("jodTf");

var $eyhSG = parcelRequire("eyhSG");

parcelRequire("a9Eub");
parcelRequire("fyBbG");
parcelRequire("g5hub");
parcelRequire("lF4lh");
parcelRequire("4867A");
parcelRequire("a9qSP");
parcelRequire("3kSK9");
parcelRequire("2DbVd");

parcelRequire("bnuVp");
parcelRequire("9lyXk");
parcelRequire("iYS30");
parcelRequire("5ORM1");

parcelRequire("aoLZt");
var $b6ed8d87cb828221$var$StateManagedSelect = /*#__PURE__*/ (0, $gOovR.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $5smQ2.u)(props);
    return /*#__PURE__*/ $gOovR.createElement((0, $iyuie.S), (0, $h3G97.default)({
        ref: ref
    }, baseSelectProps));
});
var $b6ed8d87cb828221$export$2e2bcd8739ae039 = $b6ed8d87cb828221$var$StateManagedSelect;
var $b6ed8d87cb828221$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $gOovR.useMemo)(function() {
        return (0, $eyhSG.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $gOovR.createElement((0, $jodTf.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("5smQ2", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $3f91487bd75c7cec$export$3b14a55fb2447963; });

var $cM4HV = parcelRequire("cM4HV");

var $h6JTI = parcelRequire("h6JTI");

var $i9Zjy = parcelRequire("i9Zjy");

var $gOovR = parcelRequire("gOovR");
var $3f91487bd75c7cec$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $3f91487bd75c7cec$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $i9Zjy.default)(_ref, $3f91487bd75c7cec$var$_excluded);
    var _useState = (0, $gOovR.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $h6JTI.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $gOovR.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $h6JTI.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $gOovR.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $h6JTI.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $gOovR.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $gOovR.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $gOovR.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $gOovR.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $cM4HV.default)((0, $cM4HV.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("cM4HV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94cd9e8748613303$export$2e2bcd8739ae039; });

var $iHrdN = parcelRequire("iHrdN");
function $94cd9e8748613303$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94cd9e8748613303$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94cd9e8748613303$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iHrdN.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94cd9e8748613303$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("h6JTI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c746997f973156af$export$2e2bcd8739ae039; });

var $h15GA = parcelRequire("h15GA");

var $iDFOy = parcelRequire("iDFOy");

var $B3t6K = parcelRequire("B3t6K");

var $dNIST = parcelRequire("dNIST");
function $c746997f973156af$export$2e2bcd8739ae039(r, e) {
    return (0, $h15GA.default)(r) || (0, $iDFOy.default)(r, e) || (0, $B3t6K.default)(r, e) || (0, $dNIST.default)();
}

});
parcelRegister("h15GA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c636f0c5ef93fede$export$2e2bcd8739ae039; });
function $c636f0c5ef93fede$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("iDFOy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d91c4dfbfdeb7fcf$export$2e2bcd8739ae039; });
function $d91c4dfbfdeb7fcf$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("B3t6K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06f625958d55ed0d$export$2e2bcd8739ae039; });

var $8sXhu = parcelRequire("8sXhu");
function $06f625958d55ed0d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $8sXhu.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $8sXhu.default)(r, a) : void 0;
    }
}

});
parcelRegister("8sXhu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $629eec3e4497601d$export$2e2bcd8739ae039; });
function $629eec3e4497601d$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dNIST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0c2ab0e0a593804$export$2e2bcd8739ae039; });
function $a0c2ab0e0a593804$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("i9Zjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d388a108044338f6$export$2e2bcd8739ae039; });

var $eNjeQ = parcelRequire("eNjeQ");
function $d388a108044338f6$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $eNjeQ.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("iyuie", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $d822e68a92846da6$export$25ce5a424b770e84; });

var $h3G97 = parcelRequire("h3G97");

var $cM4HV = parcelRequire("cM4HV");

var $fAOD4 = parcelRequire("fAOD4");

var $lgAxg = parcelRequire("lgAxg");

var $8E4Nj = parcelRequire("8E4Nj");

var $10kIq = parcelRequire("10kIq");

var $bEat1 = parcelRequire("bEat1");

var $gOovR = parcelRequire("gOovR");

var $5rrpU = parcelRequire("5rrpU");

var $5tG4L = parcelRequire("5tG4L");

var $dLDsN = parcelRequire("dLDsN");

var $i9Zjy = parcelRequire("i9Zjy");
function $d822e68a92846da6$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $d822e68a92846da6$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $d822e68a92846da6$var$A11yText = function A11yText(props) {
    return (0, $5tG4L.jsx)("span", (0, $h3G97.default)({
        css: $d822e68a92846da6$var$_ref
    }, props));
};
var $d822e68a92846da6$var$A11yText$1 = $d822e68a92846da6$var$A11yText;
var $d822e68a92846da6$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $d822e68a92846da6$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $gOovR.useMemo)(function() {
        return (0, $cM4HV.default)((0, $cM4HV.default)({}, $d822e68a92846da6$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $gOovR.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $cM4HV.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $gOovR.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $gOovR.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $gOovR.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $5tG4L.jsx)((0, $gOovR.Fragment), null, (0, $5tG4L.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $5tG4L.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $5tG4L.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $5tG4L.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $5tG4L.jsx)((0, $gOovR.Fragment), null, (0, $5tG4L.jsx)($d822e68a92846da6$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $5tG4L.jsx)($d822e68a92846da6$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $d822e68a92846da6$var$LiveRegion$1 = $d822e68a92846da6$var$LiveRegion;
var $d822e68a92846da6$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $d822e68a92846da6$var$anyDiacritic = new RegExp("[" + $d822e68a92846da6$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $d822e68a92846da6$var$diacriticToBase = {};
for(var $d822e68a92846da6$var$i = 0; $d822e68a92846da6$var$i < $d822e68a92846da6$var$diacritics.length; $d822e68a92846da6$var$i++){
    var $d822e68a92846da6$var$diacritic = $d822e68a92846da6$var$diacritics[$d822e68a92846da6$var$i];
    for(var $d822e68a92846da6$var$j = 0; $d822e68a92846da6$var$j < $d822e68a92846da6$var$diacritic.letters.length; $d822e68a92846da6$var$j++)$d822e68a92846da6$var$diacriticToBase[$d822e68a92846da6$var$diacritic.letters[$d822e68a92846da6$var$j]] = $d822e68a92846da6$var$diacritic.base;
}
var $d822e68a92846da6$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($d822e68a92846da6$var$anyDiacritic, function(match) {
        return $d822e68a92846da6$var$diacriticToBase[match];
    });
};
var $d822e68a92846da6$var$memoizedStripDiacriticsForInput = (0, $dLDsN.default)($d822e68a92846da6$var$stripDiacritics);
var $d822e68a92846da6$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $d822e68a92846da6$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $d822e68a92846da6$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $cM4HV.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $d822e68a92846da6$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $d822e68a92846da6$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $d822e68a92846da6$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $d822e68a92846da6$var$memoizedStripDiacriticsForInput(input);
            candidate = $d822e68a92846da6$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $d822e68a92846da6$var$_excluded = [
    "innerRef"
];
function $d822e68a92846da6$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $i9Zjy.default)(_ref, $d822e68a92846da6$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $5rrpU.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $5tG4L.jsx)("input", (0, $h3G97.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $5tG4L.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $d822e68a92846da6$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $d822e68a92846da6$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $gOovR.useRef)(false);
    var isTop = (0, $gOovR.useRef)(false);
    var touchStart = (0, $gOovR.useRef)(0);
    var scrollTarget = (0, $gOovR.useRef)(null);
    var handleEventDelta = (0, $gOovR.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $d822e68a92846da6$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $gOovR.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $gOovR.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $gOovR.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $gOovR.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $5rrpU.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $gOovR.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $gOovR.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $d822e68a92846da6$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $d822e68a92846da6$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $d822e68a92846da6$var$preventTouchMove(e) {
    e.preventDefault();
}
function $d822e68a92846da6$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $d822e68a92846da6$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $d822e68a92846da6$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $d822e68a92846da6$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $d822e68a92846da6$var$activeScrollLocks = 0;
var $d822e68a92846da6$var$listenerOptions = {
    capture: false,
    passive: false
};
function $d822e68a92846da6$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $gOovR.useRef)({});
    var scrollTarget = (0, $gOovR.useRef)(null);
    var addScrollLock = (0, $gOovR.useCallback)(function(touchScrollTarget) {
        if (!$d822e68a92846da6$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $d822e68a92846da6$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $d822e68a92846da6$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($d822e68a92846da6$var$LOCK_STYLES).forEach(function(key) {
                var val = $d822e68a92846da6$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $d822e68a92846da6$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $d822e68a92846da6$var$preventTouchMove, $d822e68a92846da6$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $d822e68a92846da6$var$preventInertiaScroll, $d822e68a92846da6$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $d822e68a92846da6$var$allowTouchMove, $d822e68a92846da6$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $d822e68a92846da6$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $gOovR.useCallback)(function(touchScrollTarget) {
        if (!$d822e68a92846da6$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $d822e68a92846da6$var$activeScrollLocks = Math.max($d822e68a92846da6$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $d822e68a92846da6$var$activeScrollLocks < 1) $d822e68a92846da6$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $d822e68a92846da6$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $d822e68a92846da6$var$preventTouchMove, $d822e68a92846da6$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $d822e68a92846da6$var$preventInertiaScroll, $d822e68a92846da6$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $d822e68a92846da6$var$allowTouchMove, $d822e68a92846da6$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $gOovR.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $d822e68a92846da6$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d822e68a92846da6$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $d822e68a92846da6$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $d822e68a92846da6$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $d822e68a92846da6$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $d822e68a92846da6$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $5tG4L.jsx)((0, $gOovR.Fragment), null, lockEnabled && (0, $5tG4L.jsx)("div", {
        onClick: $d822e68a92846da6$var$blurSelectInput,
        css: $d822e68a92846da6$var$_ref2$1
    }), children(targetRef));
}
function $d822e68a92846da6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d822e68a92846da6$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $d822e68a92846da6$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $5tG4L.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $d822e68a92846da6$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $d822e68a92846da6$var$RequiredInput$1 = $d822e68a92846da6$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $d822e68a92846da6$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $d822e68a92846da6$var$isIPhone() {
    return $d822e68a92846da6$var$testPlatform(/^iPhone/i);
}
function $d822e68a92846da6$var$isMac() {
    return $d822e68a92846da6$var$testPlatform(/^Mac/i);
}
function $d822e68a92846da6$var$isIPad() {
    return $d822e68a92846da6$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $d822e68a92846da6$var$isMac() && navigator.maxTouchPoints > 1;
}
function $d822e68a92846da6$var$isIOS() {
    return $d822e68a92846da6$var$isIPhone() || $d822e68a92846da6$var$isIPad();
}
function $d822e68a92846da6$var$isAppleDevice() {
    return $d822e68a92846da6$var$isMac() || $d822e68a92846da6$var$isIOS();
}
var $d822e68a92846da6$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $d822e68a92846da6$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $d822e68a92846da6$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $d822e68a92846da6$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $d822e68a92846da6$var$defaultStyles = {
    clearIndicator: (0, $5rrpU.a),
    container: (0, $5rrpU.b),
    control: (0, $5rrpU.d),
    dropdownIndicator: (0, $5rrpU.e),
    group: (0, $5rrpU.g),
    groupHeading: (0, $5rrpU.f),
    indicatorsContainer: (0, $5rrpU.i),
    indicatorSeparator: (0, $5rrpU.h),
    input: (0, $5rrpU.j),
    loadingIndicator: (0, $5rrpU.l),
    loadingMessage: (0, $5rrpU.k),
    menu: (0, $5rrpU.m),
    menuList: (0, $5rrpU.n),
    menuPortal: (0, $5rrpU.o),
    multiValue: (0, $5rrpU.p),
    multiValueLabel: (0, $5rrpU.q),
    multiValueRemove: (0, $5rrpU.t),
    noOptionsMessage: (0, $5rrpU.u),
    option: (0, $5rrpU.v),
    placeholder: (0, $5rrpU.w),
    singleValue: (0, $5rrpU.x),
    valueContainer: (0, $5rrpU.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $d822e68a92846da6$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $cM4HV.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $d822e68a92846da6$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $d822e68a92846da6$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $d822e68a92846da6$var$baseUnit = 4;
// The minimum height of the control
var $d822e68a92846da6$var$controlHeight = 38;
// The amount of space between the control and menu */
var $d822e68a92846da6$var$menuGutter = $d822e68a92846da6$var$baseUnit * 2;
var $d822e68a92846da6$var$spacing = {
    baseUnit: $d822e68a92846da6$var$baseUnit,
    controlHeight: $d822e68a92846da6$var$controlHeight,
    menuGutter: $d822e68a92846da6$var$menuGutter
};
var $d822e68a92846da6$export$4368d992c4eafac0 = {
    borderRadius: $d822e68a92846da6$var$borderRadius,
    colors: $d822e68a92846da6$var$colors,
    spacing: $d822e68a92846da6$var$spacing
};
var $d822e68a92846da6$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $5rrpU.z)(),
    captureMenuScroll: !(0, $5rrpU.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $d822e68a92846da6$export$db3b6bfb95261072(),
    formatGroupLabel: $d822e68a92846da6$var$formatGroupLabel,
    getOptionLabel: $d822e68a92846da6$export$8b22cf2602fb60ce,
    getOptionValue: $d822e68a92846da6$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $d822e68a92846da6$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $5rrpU.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $d822e68a92846da6$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $d822e68a92846da6$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $d822e68a92846da6$var$_isOptionSelected(props, option, selectValue);
    var label = $d822e68a92846da6$var$getOptionLabel(props, option);
    var value = $d822e68a92846da6$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d822e68a92846da6$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $d822e68a92846da6$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $d822e68a92846da6$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $d822e68a92846da6$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d822e68a92846da6$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $5rrpU.K));
}
function $d822e68a92846da6$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $bEat1.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d822e68a92846da6$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $bEat1.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $d822e68a92846da6$var$buildFocusableOptions(props, selectValue) {
    return $d822e68a92846da6$var$buildFocusableOptionsFromCategorizedOptions($d822e68a92846da6$var$buildCategorizedOptions(props, selectValue));
}
function $d822e68a92846da6$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$d822e68a92846da6$var$shouldHideSelectedOptions(props) || !isSelected) && $d822e68a92846da6$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d822e68a92846da6$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d822e68a92846da6$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $d822e68a92846da6$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $d822e68a92846da6$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $d822e68a92846da6$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $d822e68a92846da6$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $d822e68a92846da6$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $d822e68a92846da6$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $d822e68a92846da6$var$getOptionValue(props, i) === candidate;
    });
}
function $d822e68a92846da6$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $d822e68a92846da6$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $d822e68a92846da6$var$instanceId = 1;
var $d822e68a92846da6$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $8E4Nj.default)(Select, _Component);
    var _super = (0, $10kIq.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $fAOD4.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $d822e68a92846da6$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $5rrpU.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $5rrpU.B)([].concat((0, $bEat1.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $5rrpU.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $5rrpU.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $5rrpU.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $5rrpU.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $5rrpU.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $d822e68a92846da6$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $d822e68a92846da6$var$buildFocusableOptionsWithIds($d822e68a92846da6$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $5rrpU.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $d822e68a92846da6$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $d822e68a92846da6$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $d822e68a92846da6$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $5rrpU.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $d822e68a92846da6$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $d822e68a92846da6$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $cM4HV.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $5rrpU.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $d822e68a92846da6$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$d822e68a92846da6$var$instanceId);
        _this.state.selectValue = (0, $5rrpU.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $d822e68a92846da6$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $lgAxg.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $5rrpU.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $5rrpU.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $d822e68a92846da6$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($d822e68a92846da6$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $cM4HV.default)((0, $cM4HV.default)({}, $d822e68a92846da6$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $d822e68a92846da6$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $d822e68a92846da6$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $d822e68a92846da6$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $cM4HV.default)((0, $cM4HV.default)((0, $cM4HV.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $gOovR.createElement($d822e68a92846da6$var$DummyInput, (0, $h3G97.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $5rrpU.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $gOovR.createElement(Input, (0, $h3G97.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $gOovR.createElement(Placeholder, (0, $h3G97.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $gOovR.createElement(MultiValue, (0, $h3G97.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $gOovR.createElement(SingleValue, (0, $h3G97.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $gOovR.createElement(ClearIndicator, (0, $h3G97.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $gOovR.createElement(LoadingIndicator, (0, $h3G97.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $gOovR.createElement(IndicatorSeparator, (0, $h3G97.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $gOovR.createElement(DropdownIndicator, (0, $h3G97.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $gOovR.createElement(Option, (0, $h3G97.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $gOovR.createElement(Group, (0, $h3G97.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $gOovR.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $gOovR.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $gOovR.createElement((0, $5rrpU.M), (0, $h3G97.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $gOovR.createElement(Menu, (0, $h3G97.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $gOovR.createElement($d822e68a92846da6$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $gOovR.createElement(MenuList, (0, $h3G97.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $gOovR.createElement(MenuPortal, (0, $h3G97.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $gOovR.createElement($d822e68a92846da6$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $gOovR.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $gOovR.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $gOovR.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $gOovR.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $gOovR.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $gOovR.createElement($d822e68a92846da6$var$LiveRegion$1, (0, $h3G97.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $gOovR.createElement(SelectContainer, (0, $h3G97.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $gOovR.createElement(Control, (0, $h3G97.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $gOovR.createElement(ValueContainer, (0, $h3G97.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $gOovR.createElement(IndicatorsContainer, (0, $h3G97.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $5rrpU.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $d822e68a92846da6$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $d822e68a92846da6$var$buildFocusableOptionsWithIds($d822e68a92846da6$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $d822e68a92846da6$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $d822e68a92846da6$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $d822e68a92846da6$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $5rrpU.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $cM4HV.default)((0, $cM4HV.default)((0, $cM4HV.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $gOovR.Component));
$d822e68a92846da6$export$25ce5a424b770e84.defaultProps = $d822e68a92846da6$export$407448d2b89b1813;

});
parcelRegister("fAOD4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5a17dba2e1d5fbf$export$2e2bcd8739ae039; });
function $b5a17dba2e1d5fbf$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lgAxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7b76ec9f0c5bded$export$2e2bcd8739ae039; });

var $89blb = parcelRequire("89blb");
function $f7b76ec9f0c5bded$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $89blb.default)(o.key), o);
    }
}
function $f7b76ec9f0c5bded$export$2e2bcd8739ae039(e, r, t) {
    return r && $f7b76ec9f0c5bded$var$_defineProperties(e.prototype, r), t && $f7b76ec9f0c5bded$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("8E4Nj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64b5c733b65d380a$export$2e2bcd8739ae039; });

var $2soB1 = parcelRequire("2soB1");
function $64b5c733b65d380a$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $2soB1.default)(t, e);
}

});

parcelRegister("10kIq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bb5dc2f39d2613d$export$2e2bcd8739ae039; });

var $2jKzX = parcelRequire("2jKzX");

var $83aZw = parcelRequire("83aZw");

var $6BYcC = parcelRequire("6BYcC");
function $0bb5dc2f39d2613d$export$2e2bcd8739ae039(t) {
    var r = (0, $83aZw.default)();
    return function() {
        var e, o = (0, $2jKzX.default)(t);
        if (r) {
            var s = (0, $2jKzX.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6BYcC.default)(this, e);
    };
}

});
parcelRegister("2jKzX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b017cb4974ea13a$export$2e2bcd8739ae039; });
function $1b017cb4974ea13a$export$2e2bcd8739ae039(t) {
    return $1b017cb4974ea13a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $1b017cb4974ea13a$export$2e2bcd8739ae039(t);
}

});

parcelRegister("83aZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0183363688f45920$export$2e2bcd8739ae039; });
function $0183363688f45920$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0183363688f45920$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("6BYcC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d04e5c13ae3adf1$export$2e2bcd8739ae039; });

var $7411b = parcelRequire("7411b");

var $8gWG2 = parcelRequire("8gWG2");
function $4d04e5c13ae3adf1$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7411b.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $8gWG2.default)(t);
}

});


parcelRegister("bEat1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87ab8caf3bf40adf$export$2e2bcd8739ae039; });

var $zXCGX = parcelRequire("zXCGX");

var $7yG2D = parcelRequire("7yG2D");

var $B3t6K = parcelRequire("B3t6K");

var $017AZ = parcelRequire("017AZ");
function $87ab8caf3bf40adf$export$2e2bcd8739ae039(r) {
    return (0, $zXCGX.default)(r) || (0, $7yG2D.default)(r) || (0, $B3t6K.default)(r) || (0, $017AZ.default)();
}

});
parcelRegister("zXCGX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06c184e5a24cee78$export$2e2bcd8739ae039; });

var $8sXhu = parcelRequire("8sXhu");
function $06c184e5a24cee78$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $8sXhu.default)(r);
}

});

parcelRegister("7yG2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $580c51f498ce9a12$export$2e2bcd8739ae039; });
function $580c51f498ce9a12$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("017AZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0035fc778af8ffb9$export$2e2bcd8739ae039; });
function $0035fc778af8ffb9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("5rrpU", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $3f64bdc3aeed3ef4$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $3f64bdc3aeed3ef4$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $3f64bdc3aeed3ef4$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $3f64bdc3aeed3ef4$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $3f64bdc3aeed3ef4$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $3f64bdc3aeed3ef4$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $3f64bdc3aeed3ef4$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $3f64bdc3aeed3ef4$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $3f64bdc3aeed3ef4$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $3f64bdc3aeed3ef4$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $3f64bdc3aeed3ef4$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $3f64bdc3aeed3ef4$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $3f64bdc3aeed3ef4$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $3f64bdc3aeed3ef4$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $3f64bdc3aeed3ef4$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $3f64bdc3aeed3ef4$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $3f64bdc3aeed3ef4$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $3f64bdc3aeed3ef4$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $3f64bdc3aeed3ef4$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $3f64bdc3aeed3ef4$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $3f64bdc3aeed3ef4$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $3f64bdc3aeed3ef4$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $3f64bdc3aeed3ef4$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $3f64bdc3aeed3ef4$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $3f64bdc3aeed3ef4$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $3f64bdc3aeed3ef4$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $3f64bdc3aeed3ef4$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $3f64bdc3aeed3ef4$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $3f64bdc3aeed3ef4$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $3f64bdc3aeed3ef4$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $3f64bdc3aeed3ef4$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $3f64bdc3aeed3ef4$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $3f64bdc3aeed3ef4$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $3f64bdc3aeed3ef4$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $3f64bdc3aeed3ef4$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $3f64bdc3aeed3ef4$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "F", function () { return $3f64bdc3aeed3ef4$export$d66501df72047452; });

var $cM4HV = parcelRequire("cM4HV");

var $h3G97 = parcelRequire("h3G97");

var $5tG4L = parcelRequire("5tG4L");

var $h6JTI = parcelRequire("h6JTI");

var $i9Zjy = parcelRequire("i9Zjy");

var $7411b = parcelRequire("7411b");

var $cimYz = parcelRequire("cimYz");

var $iHrdN = parcelRequire("iHrdN");

var $gOovR = parcelRequire("gOovR");

var $5ORM1 = parcelRequire("5ORM1");

var $6T9M7 = parcelRequire("6T9M7");

var $aoLZt = parcelRequire("aoLZt");
var $3f64bdc3aeed3ef4$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $3f64bdc3aeed3ef4$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $3f64bdc3aeed3ef4$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $3f64bdc3aeed3ef4$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($3f64bdc3aeed3ef4$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $3f64bdc3aeed3ef4$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($3f64bdc3aeed3ef4$var$isArray(value)) return value.filter(Boolean);
    if ((0, $7411b.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $3f64bdc3aeed3ef4$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $i9Zjy.default)(props, $3f64bdc3aeed3ef4$var$_excluded$4);
    return (0, $cM4HV.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $3f64bdc3aeed3ef4$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $3f64bdc3aeed3ef4$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $3f64bdc3aeed3ef4$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $3f64bdc3aeed3ef4$var$normalizedHeight(el) {
    if ($3f64bdc3aeed3ef4$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $3f64bdc3aeed3ef4$var$getScrollTop(el) {
    if ($3f64bdc3aeed3ef4$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $3f64bdc3aeed3ef4$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($3f64bdc3aeed3ef4$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $3f64bdc3aeed3ef4$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $3f64bdc3aeed3ef4$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $3f64bdc3aeed3ef4$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $3f64bdc3aeed3ef4$export$b4171a6734a65d42;
    var start = $3f64bdc3aeed3ef4$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $3f64bdc3aeed3ef4$var$easeOutCubic(currentTime, start, change, duration);
        $3f64bdc3aeed3ef4$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $3f64bdc3aeed3ef4$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $3f64bdc3aeed3ef4$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $3f64bdc3aeed3ef4$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $3f64bdc3aeed3ef4$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $3f64bdc3aeed3ef4$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $3f64bdc3aeed3ef4$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $3f64bdc3aeed3ef4$var$passiveOptionAccessed = false;
var $3f64bdc3aeed3ef4$var$options = {
    get passive () {
        return $3f64bdc3aeed3ef4$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $3f64bdc3aeed3ef4$var$w = typeof window !== "undefined" ? window : {};
if ($3f64bdc3aeed3ef4$var$w.addEventListener && $3f64bdc3aeed3ef4$var$w.removeEventListener) {
    $3f64bdc3aeed3ef4$var$w.addEventListener("p", $3f64bdc3aeed3ef4$export$b4171a6734a65d42, $3f64bdc3aeed3ef4$var$options);
    $3f64bdc3aeed3ef4$var$w.removeEventListener("p", $3f64bdc3aeed3ef4$export$b4171a6734a65d42, false);
}
var $3f64bdc3aeed3ef4$export$2408f22a0fab9ae5 = $3f64bdc3aeed3ef4$var$passiveOptionAccessed;
function $3f64bdc3aeed3ef4$export$3466f893ebf79586(item) {
    return item != null;
}
function $3f64bdc3aeed3ef4$var$isArray(arg) {
    return Array.isArray(arg);
}
function $3f64bdc3aeed3ef4$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $3f64bdc3aeed3ef4$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $3f64bdc3aeed3ef4$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $3f64bdc3aeed3ef4$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $h6JTI.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $h6JTI.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $3f64bdc3aeed3ef4$var$_excluded$3 = [
    "children",
    "innerProps"
], $3f64bdc3aeed3ef4$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $3f64bdc3aeed3ef4$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $3f64bdc3aeed3ef4$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $3f64bdc3aeed3ef4$var$normalizedHeight(scrollParent);
    var scrollTop = $3f64bdc3aeed3ef4$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $3f64bdc3aeed3ef4$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $3f64bdc3aeed3ef4$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $3f64bdc3aeed3ef4$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $3f64bdc3aeed3ef4$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $3f64bdc3aeed3ef4$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $3f64bdc3aeed3ef4$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $3f64bdc3aeed3ef4$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $3f64bdc3aeed3ef4$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $cM4HV.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $iHrdN.default)(_objectSpread2, $3f64bdc3aeed3ef4$var$alignToControl(placement), "100%"), (0, $iHrdN.default)(_objectSpread2, "position", "absolute"), (0, $iHrdN.default)(_objectSpread2, "width", "100%"), (0, $iHrdN.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $3f64bdc3aeed3ef4$var$PortalPlacementContext = /*#__PURE__*/ (0, $gOovR.createContext)(null);
// NOTE: internal only
var $3f64bdc3aeed3ef4$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $gOovR.useContext)($3f64bdc3aeed3ef4$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $gOovR.useRef)(null);
    var _useState = (0, $gOovR.useState)(maxMenuHeight), _useState2 = (0, $h6JTI.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $gOovR.useState)(null), _useState4 = (0, $h6JTI.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $aoLZt.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $3f64bdc3aeed3ef4$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $cM4HV.default)((0, $cM4HV.default)({}, props), {}, {
            placement: placement || $3f64bdc3aeed3ef4$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $3f64bdc3aeed3ef4$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $3f64bdc3aeed3ef4$var$Menu$1 = $3f64bdc3aeed3ef4$var$Menu;
// ==============================
// Menu List
// ==============================
var $3f64bdc3aeed3ef4$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $cM4HV.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $3f64bdc3aeed3ef4$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $3f64bdc3aeed3ef4$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $cM4HV.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $3f64bdc3aeed3ef4$export$3b14a55fb2447963 = $3f64bdc3aeed3ef4$var$noticeCSS;
var $3f64bdc3aeed3ef4$export$342063e11d6c3cad = $3f64bdc3aeed3ef4$var$noticeCSS;
var $3f64bdc3aeed3ef4$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $i9Zjy.default)(_ref6, $3f64bdc3aeed3ef4$var$_excluded$3);
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps((0, $cM4HV.default)((0, $cM4HV.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $3f64bdc3aeed3ef4$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $i9Zjy.default)(_ref7, $3f64bdc3aeed3ef4$var$_excluded2$1);
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps((0, $cM4HV.default)((0, $cM4HV.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $3f64bdc3aeed3ef4$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $3f64bdc3aeed3ef4$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $gOovR.useRef)(null);
    var cleanupRef = (0, $gOovR.useRef)(null);
    var _useState5 = (0, $gOovR.useState)($3f64bdc3aeed3ef4$var$coercePlacement(menuPlacement)), _useState6 = (0, $h6JTI.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $gOovR.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $gOovR.useState)(null), _useState8 = (0, $h6JTI.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $gOovR.useCallback)(function() {
        if (!controlElement) return;
        var rect = $3f64bdc3aeed3ef4$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $aoLZt.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $gOovR.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6T9M7.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $aoLZt.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $gOovR.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $5tG4L.jsx)("div", (0, $h3G97.default)({
        ref: setMenuPortalElement
    }, $3f64bdc3aeed3ef4$var$getStyleProps((0, $cM4HV.default)((0, $cM4HV.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $5ORM1.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $3f64bdc3aeed3ef4$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $3f64bdc3aeed3ef4$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $3f64bdc3aeed3ef4$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $cM4HV.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $3f64bdc3aeed3ef4$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $3f64bdc3aeed3ef4$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $3f64bdc3aeed3ef4$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $3f64bdc3aeed3ef4$var$_templateObject;
var $3f64bdc3aeed3ef4$var$_excluded$2 = [
    "size"
], $3f64bdc3aeed3ef4$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $3f64bdc3aeed3ef4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $3f64bdc3aeed3ef4$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $3f64bdc3aeed3ef4$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $i9Zjy.default)(_ref, $3f64bdc3aeed3ef4$var$_excluded$2);
    return (0, $5tG4L.jsx)("svg", (0, $h3G97.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $3f64bdc3aeed3ef4$var$_ref2
    }, props));
};
var $3f64bdc3aeed3ef4$var$CrossIcon = function CrossIcon(props) {
    return (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$Svg, (0, $h3G97.default)({
        size: 20
    }, props), (0, $5tG4L.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $3f64bdc3aeed3ef4$var$DownChevron = function DownChevron(props) {
    return (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$Svg, (0, $h3G97.default)({
        size: 20
    }, props), (0, $5tG4L.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $3f64bdc3aeed3ef4$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $cM4HV.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $3f64bdc3aeed3ef4$export$f1e1789686576879 = $3f64bdc3aeed3ef4$var$baseCSS;
var $3f64bdc3aeed3ef4$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$DownChevron, null));
};
var $3f64bdc3aeed3ef4$export$407448d2b89b1813 = $3f64bdc3aeed3ef4$var$baseCSS;
var $3f64bdc3aeed3ef4$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $3f64bdc3aeed3ef4$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $cM4HV.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $3f64bdc3aeed3ef4$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $5tG4L.jsx)("span", (0, $h3G97.default)({}, innerProps, $3f64bdc3aeed3ef4$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $3f64bdc3aeed3ef4$var$loadingDotAnimations = (0, $5tG4L.keyframes)($3f64bdc3aeed3ef4$var$_templateObject || ($3f64bdc3aeed3ef4$var$_templateObject = (0, $cimYz.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $3f64bdc3aeed3ef4$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $cM4HV.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $3f64bdc3aeed3ef4$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $5tG4L.jsx)("span", {
        css: /*#__PURE__*/ (0, $5tG4L.css)({
            animation: "".concat($3f64bdc3aeed3ef4$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $3f64bdc3aeed3ef4$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $i9Zjy.default)(_ref7, $3f64bdc3aeed3ef4$var$_excluded2);
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps((0, $cM4HV.default)((0, $cM4HV.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $3f64bdc3aeed3ef4$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $cM4HV.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $3f64bdc3aeed3ef4$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({
        ref: innerRef
    }, $3f64bdc3aeed3ef4$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $3f64bdc3aeed3ef4$var$Control$1 = $3f64bdc3aeed3ef4$var$Control;
var $3f64bdc3aeed3ef4$var$_excluded$1 = [
    "data"
];
var $3f64bdc3aeed3ef4$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $3f64bdc3aeed3ef4$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $5tG4L.jsx)(Heading, (0, $h3G97.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $5tG4L.jsx)("div", null, children));
};
var $3f64bdc3aeed3ef4$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $cM4HV.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $3f64bdc3aeed3ef4$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $3f64bdc3aeed3ef4$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $i9Zjy.default)(_cleanCommonProps, $3f64bdc3aeed3ef4$var$_excluded$1);
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $3f64bdc3aeed3ef4$var$Group$1 = $3f64bdc3aeed3ef4$var$Group;
var $3f64bdc3aeed3ef4$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $3f64bdc3aeed3ef4$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $cM4HV.default)((0, $cM4HV.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $3f64bdc3aeed3ef4$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $3f64bdc3aeed3ef4$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $3f64bdc3aeed3ef4$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $cM4HV.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $3f64bdc3aeed3ef4$var$spacingStyle)
};
var $3f64bdc3aeed3ef4$var$inputStyle = function inputStyle(isHidden) {
    return (0, $cM4HV.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $3f64bdc3aeed3ef4$var$spacingStyle);
};
var $3f64bdc3aeed3ef4$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $3f64bdc3aeed3ef4$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $i9Zjy.default)(_cleanCommonProps, $3f64bdc3aeed3ef4$var$_excluded);
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $5tG4L.jsx)("input", (0, $h3G97.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $3f64bdc3aeed3ef4$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $3f64bdc3aeed3ef4$var$Input$1 = $3f64bdc3aeed3ef4$var$Input;
var $3f64bdc3aeed3ef4$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $cM4HV.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $3f64bdc3aeed3ef4$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $cM4HV.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $3f64bdc3aeed3ef4$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $cM4HV.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $3f64bdc3aeed3ef4$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $5tG4L.jsx)("div", innerProps, children);
};
var $3f64bdc3aeed3ef4$var$MultiValueContainer = $3f64bdc3aeed3ef4$var$MultiValueGeneric;
var $3f64bdc3aeed3ef4$var$MultiValueLabel = $3f64bdc3aeed3ef4$var$MultiValueGeneric;
function $3f64bdc3aeed3ef4$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({
        role: "button"
    }, innerProps), children || (0, $5tG4L.jsx)($3f64bdc3aeed3ef4$var$CrossIcon, {
        size: 14
    }));
}
var $3f64bdc3aeed3ef4$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $5tG4L.jsx)(Container, {
        data: data,
        innerProps: (0, $cM4HV.default)((0, $cM4HV.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $5tG4L.jsx)(Label, {
        data: data,
        innerProps: (0, $cM4HV.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $5tG4L.jsx)(Remove, {
        data: data,
        innerProps: (0, $cM4HV.default)((0, $cM4HV.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $3f64bdc3aeed3ef4$var$MultiValue$1 = $3f64bdc3aeed3ef4$var$MultiValue;
var $3f64bdc3aeed3ef4$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $cM4HV.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $3f64bdc3aeed3ef4$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $3f64bdc3aeed3ef4$var$Option$1 = $3f64bdc3aeed3ef4$var$Option;
var $3f64bdc3aeed3ef4$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $cM4HV.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $3f64bdc3aeed3ef4$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $3f64bdc3aeed3ef4$var$Placeholder$1 = $3f64bdc3aeed3ef4$var$Placeholder;
var $3f64bdc3aeed3ef4$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $cM4HV.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $3f64bdc3aeed3ef4$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $5tG4L.jsx)("div", (0, $h3G97.default)({}, $3f64bdc3aeed3ef4$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $3f64bdc3aeed3ef4$var$SingleValue$1 = $3f64bdc3aeed3ef4$var$SingleValue;
var $3f64bdc3aeed3ef4$export$db3b6bfb95261072 = {
    ClearIndicator: $3f64bdc3aeed3ef4$var$ClearIndicator,
    Control: $3f64bdc3aeed3ef4$var$Control$1,
    DropdownIndicator: $3f64bdc3aeed3ef4$var$DropdownIndicator,
    DownChevron: $3f64bdc3aeed3ef4$var$DownChevron,
    CrossIcon: $3f64bdc3aeed3ef4$var$CrossIcon,
    Group: $3f64bdc3aeed3ef4$var$Group$1,
    GroupHeading: $3f64bdc3aeed3ef4$var$GroupHeading,
    IndicatorsContainer: $3f64bdc3aeed3ef4$var$IndicatorsContainer,
    IndicatorSeparator: $3f64bdc3aeed3ef4$var$IndicatorSeparator,
    Input: $3f64bdc3aeed3ef4$var$Input$1,
    LoadingIndicator: $3f64bdc3aeed3ef4$var$LoadingIndicator,
    Menu: $3f64bdc3aeed3ef4$var$Menu$1,
    MenuList: $3f64bdc3aeed3ef4$var$MenuList,
    MenuPortal: $3f64bdc3aeed3ef4$var$MenuPortal,
    LoadingMessage: $3f64bdc3aeed3ef4$var$LoadingMessage,
    NoOptionsMessage: $3f64bdc3aeed3ef4$var$NoOptionsMessage,
    MultiValue: $3f64bdc3aeed3ef4$var$MultiValue$1,
    MultiValueContainer: $3f64bdc3aeed3ef4$var$MultiValueContainer,
    MultiValueLabel: $3f64bdc3aeed3ef4$var$MultiValueLabel,
    MultiValueRemove: $3f64bdc3aeed3ef4$var$MultiValueRemove,
    Option: $3f64bdc3aeed3ef4$var$Option$1,
    Placeholder: $3f64bdc3aeed3ef4$var$Placeholder$1,
    SelectContainer: $3f64bdc3aeed3ef4$var$SelectContainer,
    SingleValue: $3f64bdc3aeed3ef4$var$SingleValue$1,
    ValueContainer: $3f64bdc3aeed3ef4$var$ValueContainer
};
var $3f64bdc3aeed3ef4$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $cM4HV.default)((0, $cM4HV.default)({}, $3f64bdc3aeed3ef4$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("5tG4L", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $3fd04c8dece848b2$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $3fd04c8dece848b2$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $3fd04c8dece848b2$export$c8a8987d4410bf2d; });

var $jodTf = parcelRequire("jodTf");

var $gOovR = parcelRequire("gOovR");

var $fhXxk = parcelRequire("fhXxk");

var $hwSOa = parcelRequire("hwSOa");

var $8OpE1 = parcelRequire("8OpE1");
parcelRequire("eyhSG");
parcelRequire("5WRll");
parcelRequire("jAslQ");

parcelRequire("movFX");
var $3fd04c8dece848b2$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $jodTf.h).call(props, "css")) return $gOovR.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $jodTf.E);
    createElementArgArray[1] = (0, $jodTf.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $gOovR.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3fd04c8dece848b2$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $jodTf.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8OpE1.serializeStyles)([
        styles
    ], undefined, $gOovR.useContext((0, $jodTf.T)));
    if (!(0, $jodTf.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $gOovR.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $gOovR.useRef();
    (0, $hwSOa.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $hwSOa.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $fhXxk.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $3fd04c8dece848b2$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8OpE1.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $3fd04c8dece848b2$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $3fd04c8dece848b2$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $3fd04c8dece848b2$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $3fd04c8dece848b2$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $fhXxk.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3fd04c8dece848b2$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $hwSOa.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $fhXxk.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $jodTf.i) && res !== undefined) rules += res;
        }
        if (!(0, $jodTf.i)) return rules;
    });
    if (!(0, $jodTf.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $gOovR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $3fd04c8dece848b2$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $jodTf.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $jodTf.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8OpE1.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $fhXxk.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $jodTf.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3fd04c8dece848b2$var$merge(cache.registered, css, $3fd04c8dece848b2$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $gOovR.useContext((0, $jodTf.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $gOovR.createElement($gOovR.Fragment, null, /*#__PURE__*/ $gOovR.createElement($3fd04c8dece848b2$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("jodTf", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $e1db087d7ce4d9ae$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $e1db087d7ce4d9ae$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $e1db087d7ce4d9ae$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $e1db087d7ce4d9ae$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $e1db087d7ce4d9ae$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $e1db087d7ce4d9ae$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $e1db087d7ce4d9ae$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $e1db087d7ce4d9ae$export$a9c23c6ac3fc3eca; });

var $gOovR = parcelRequire("gOovR");

var $eyhSG = parcelRequire("eyhSG");

var $h3G97 = parcelRequire("h3G97");

var $jAslQ = parcelRequire("jAslQ");

var $3dgiA = parcelRequire("3dgiA");

var $fhXxk = parcelRequire("fhXxk");

var $8OpE1 = parcelRequire("8OpE1");

var $hwSOa = parcelRequire("hwSOa");
var $e1db087d7ce4d9ae$export$407448d2b89b1813 = false;
var $e1db087d7ce4d9ae$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $e1db087d7ce4d9ae$var$EmotionCacheContext = /* #__PURE__ */ $gOovR.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $eyhSG.default)({
    key: "css"
}) : null);
var $e1db087d7ce4d9ae$export$e7094788287c5e9b = $e1db087d7ce4d9ae$var$EmotionCacheContext.Provider;
var $e1db087d7ce4d9ae$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $gOovR.useContext)($e1db087d7ce4d9ae$var$EmotionCacheContext);
};
var $e1db087d7ce4d9ae$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $gOovR.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $gOovR.useContext)($e1db087d7ce4d9ae$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e1db087d7ce4d9ae$export$23f2a1d2818174ef) $e1db087d7ce4d9ae$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $gOovR.useContext)($e1db087d7ce4d9ae$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $eyhSG.default)({
                key: "css"
            });
            return /*#__PURE__*/ $gOovR.createElement($e1db087d7ce4d9ae$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e1db087d7ce4d9ae$export$971d5caa766a69d7 = /* #__PURE__ */ $gOovR.createContext({});
var $e1db087d7ce4d9ae$export$3b14a55fb2447963 = function useTheme() {
    return $gOovR.useContext($e1db087d7ce4d9ae$export$971d5caa766a69d7);
};
var $e1db087d7ce4d9ae$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $h3G97.default)({}, outerTheme, theme);
};
var $e1db087d7ce4d9ae$var$createCacheWithTheme = /* #__PURE__ */ (0, $jAslQ.default)(function(outerTheme) {
    return (0, $jAslQ.default)(function(theme) {
        return $e1db087d7ce4d9ae$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $e1db087d7ce4d9ae$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $gOovR.useContext($e1db087d7ce4d9ae$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e1db087d7ce4d9ae$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $gOovR.createElement($e1db087d7ce4d9ae$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e1db087d7ce4d9ae$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $gOovR.useContext($e1db087d7ce4d9ae$export$971d5caa766a69d7);
        return /*#__PURE__*/ $gOovR.createElement(Component, (0, $h3G97.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $gOovR.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3dgiA.default)(WithTheme, Component);
}
var $e1db087d7ce4d9ae$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e1db087d7ce4d9ae$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $e1db087d7ce4d9ae$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($e1db087d7ce4d9ae$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$e1db087d7ce4d9ae$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $e1db087d7ce4d9ae$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fhXxk.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $hwSOa.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fhXxk.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$e1db087d7ce4d9ae$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $gOovR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e1db087d7ce4d9ae$var$Emotion = /* #__PURE__ */ $e1db087d7ce4d9ae$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e1db087d7ce4d9ae$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $fhXxk.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8OpE1.serializeStyles)(registeredStyles, undefined, $gOovR.useContext($e1db087d7ce4d9ae$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e1db087d7ce4d9ae$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $e1db087d7ce4d9ae$var$typePropName && !$e1db087d7ce4d9ae$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $gOovR.createElement($gOovR.Fragment, null, /*#__PURE__*/ $gOovR.createElement($e1db087d7ce4d9ae$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $gOovR.createElement(WrappedComponent, newProps));
});
var $e1db087d7ce4d9ae$export$a9c23c6ac3fc3eca = $e1db087d7ce4d9ae$var$Emotion;

});
parcelRegister("eyhSG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9821c6e7015f2fc$export$2e2bcd8739ae039; });

var $7K7JX = parcelRequire("7K7JX");

var $4TpyX = parcelRequire("4TpyX");

var $jAslQ = parcelRequire("jAslQ");

var $5HZ86 = parcelRequire("5HZ86");
var $a9821c6e7015f2fc$var$isBrowser = typeof document !== "undefined";
var $a9821c6e7015f2fc$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $4TpyX.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $4TpyX.token)(character)) break;
        (0, $4TpyX.next)();
    }
    return (0, $4TpyX.slice)(begin, (0, $4TpyX.position));
};
var $a9821c6e7015f2fc$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $4TpyX.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $4TpyX.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $a9821c6e7015f2fc$var$identifierWithPointTracking((0, $4TpyX.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $4TpyX.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $4TpyX.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $4TpyX.from)(character);
    }
    while (character = (0, $4TpyX.next)());
    return parsed;
};
var $a9821c6e7015f2fc$var$getRules = function getRules(value, points) {
    return (0, $4TpyX.dealloc)($a9821c6e7015f2fc$var$toRules((0, $4TpyX.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $a9821c6e7015f2fc$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $a9821c6e7015f2fc$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$a9821c6e7015f2fc$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $a9821c6e7015f2fc$var$fixedElements.set(element, true);
    var points = [];
    var rules = $a9821c6e7015f2fc$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $a9821c6e7015f2fc$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $a9821c6e7015f2fc$var$prefix(value, length) {
    switch((0, $4TpyX.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $4TpyX.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $4TpyX.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MOZ) + value + (0, $4TpyX.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + value + value;
        // order
        case 6165:
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.replace)(value, /(\w+).+(:[^]+)/, (0, $4TpyX.WEBKIT) + "box-$1$2" + (0, $4TpyX.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + "flex-item-" + (0, $4TpyX.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + "flex-line-pack" + (0, $4TpyX.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + (0, $4TpyX.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + (0, $4TpyX.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $4TpyX.WEBKIT) + "box-" + (0, $4TpyX.replace)(value, "-grow", "") + (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + (0, $4TpyX.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $4TpyX.WEBKIT) + (0, $4TpyX.replace)(value, /([^-])(transform)/g, "$1" + (0, $4TpyX.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $4TpyX.replace)((0, $4TpyX.replace)((0, $4TpyX.replace)(value, /(zoom-|grab)/, (0, $4TpyX.WEBKIT) + "$1"), /(image-set)/, (0, $4TpyX.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $4TpyX.replace)(value, /(image-set\([^]*)/, (0, $4TpyX.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $4TpyX.replace)((0, $4TpyX.replace)(value, /(.+:)(flex-)?(.*)/, (0, $4TpyX.WEBKIT) + "box-pack:$3" + (0, $4TpyX.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $4TpyX.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $4TpyX.replace)(value, /(.+)-inline(.+)/, (0, $4TpyX.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $4TpyX.strlen)(value) - 1 - length > 6) switch((0, $4TpyX.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $4TpyX.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $4TpyX.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $4TpyX.WEBKIT) + "$2-$3" + "$1" + (0, $4TpyX.MOZ) + ((0, $4TpyX.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $4TpyX.indexof)(value, "stretch") ? $a9821c6e7015f2fc$var$prefix((0, $4TpyX.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $4TpyX.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $4TpyX.charat)(value, (0, $4TpyX.strlen)(value) - 3 - (~(0, $4TpyX.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $4TpyX.replace)(value, ":", ":" + (0, $4TpyX.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $4TpyX.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $4TpyX.WEBKIT) + ((0, $4TpyX.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $4TpyX.WEBKIT) + "$2$3" + "$1" + (0, $4TpyX.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $4TpyX.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + (0, $4TpyX.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + (0, $4TpyX.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + (0, $4TpyX.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $4TpyX.WEBKIT) + value + (0, $4TpyX.MS) + value + value;
    }
    return value;
}
var $a9821c6e7015f2fc$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $4TpyX.DECLARATION:
                element["return"] = $a9821c6e7015f2fc$var$prefix(element.value, element.length);
                break;
            case 0, $4TpyX.KEYFRAMES:
                return (0, $4TpyX.serialize)([
                    (0, $4TpyX.copy)(element, {
                        value: (0, $4TpyX.replace)(element.value, "@", "@" + (0, $4TpyX.WEBKIT))
                    })
                ], callback);
            case 0, $4TpyX.RULESET:
                if (element.length) return (0, $4TpyX.combine)(element.props, function(value) {
                    switch((0, $4TpyX.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $4TpyX.serialize)([
                                (0, $4TpyX.copy)(element, {
                                    props: [
                                        (0, $4TpyX.replace)(value, /:(read-\w+)/, ":" + (0, $4TpyX.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $4TpyX.serialize)([
                                (0, $4TpyX.copy)(element, {
                                    props: [
                                        (0, $4TpyX.replace)(value, /:(plac\w+)/, ":" + (0, $4TpyX.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $4TpyX.copy)(element, {
                                    props: [
                                        (0, $4TpyX.replace)(value, /:(plac\w+)/, ":" + (0, $4TpyX.MOZ) + "$1")
                                    ]
                                }),
                                (0, $4TpyX.copy)(element, {
                                    props: [
                                        (0, $4TpyX.replace)(value, /:(plac\w+)/, (0, $4TpyX.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $a9821c6e7015f2fc$var$getServerStylisCache = $a9821c6e7015f2fc$var$isBrowser ? undefined : (0, $jAslQ.default)(function() {
    return (0, $5HZ86.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $a9821c6e7015f2fc$var$defaultStylisPlugins = [
    $a9821c6e7015f2fc$var$prefixer
];
var $a9821c6e7015f2fc$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($a9821c6e7015f2fc$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $a9821c6e7015f2fc$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($a9821c6e7015f2fc$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $a9821c6e7015f2fc$var$compat,
        $a9821c6e7015f2fc$var$removeLabel
    ];
    if ($a9821c6e7015f2fc$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $4TpyX.stringify),
            (0, $4TpyX.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $4TpyX.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $4TpyX.serialize)((0, $4TpyX.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $4TpyX.stringify)
        ];
        var _serializer = (0, $4TpyX.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $4TpyX.serialize)((0, $4TpyX.compile)(styles), _serializer);
        };
        var serverStylisCache = $a9821c6e7015f2fc$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $7K7JX.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("7K7JX", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $5a32d557eb61a068$export$9d753cd7ae895cce; });
var $5a32d557eb61a068$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $5a32d557eb61a068$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $5a32d557eb61a068$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $5a32d557eb61a068$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$5a32d557eb61a068$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($5a32d557eb61a068$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $5a32d557eb61a068$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("4TpyX", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $ab15c74af972d349$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $ab15c74af972d349$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $ab15c74af972d349$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $ab15c74af972d349$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $ab15c74af972d349$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $ab15c74af972d349$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $ab15c74af972d349$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $ab15c74af972d349$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $ab15c74af972d349$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $ab15c74af972d349$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $ab15c74af972d349$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $ab15c74af972d349$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $ab15c74af972d349$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $ab15c74af972d349$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $ab15c74af972d349$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $ab15c74af972d349$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $ab15c74af972d349$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $ab15c74af972d349$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $ab15c74af972d349$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $ab15c74af972d349$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $ab15c74af972d349$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $ab15c74af972d349$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $ab15c74af972d349$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $ab15c74af972d349$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $ab15c74af972d349$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $ab15c74af972d349$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $ab15c74af972d349$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $ab15c74af972d349$export$38bcb760f1d4871c; });
var $ab15c74af972d349$export$71ad59f2e432cfe8 = "-ms-";
var $ab15c74af972d349$export$2c0f367103c8d01c = "-moz-";
var $ab15c74af972d349$export$39dfd62a25e0fe93 = "-webkit-";
var $ab15c74af972d349$export$a29989082612d0d9 = "comm";
var $ab15c74af972d349$export$aa3a2e812ca8570d = "rule";
var $ab15c74af972d349$export$527d108ccf083c2b = "decl";
var $ab15c74af972d349$export$d3d35020fa5b54f0 = "@page";
var $ab15c74af972d349$export$500415a86c544f73 = "@media";
var $ab15c74af972d349$export$a763edbf796b780a = "@import";
var $ab15c74af972d349$export$2790aeb8b4e5c826 = "@charset";
var $ab15c74af972d349$export$1cc683e23b84b133 = "@viewport";
var $ab15c74af972d349$export$9447a5efea57e862 = "@supports";
var $ab15c74af972d349$export$ef011b4e114b1fba = "@document";
var $ab15c74af972d349$export$6aad947bda0f3f46 = "@namespace";
var $ab15c74af972d349$export$b44a8529a35fcb60 = "@keyframes";
var $ab15c74af972d349$export$2c16de31893252e6 = "@font-face";
var $ab15c74af972d349$export$3d846dd52e150c6f = "@counter-style";
var $ab15c74af972d349$export$22314bfbb57653fe = "@font-feature-values";
var $ab15c74af972d349$export$d773506282b3cfe6 = "@layer";
var $ab15c74af972d349$export$2335f513bbd82c6d = Math.abs;
var $ab15c74af972d349$export$6788812c4e6611e6 = String.fromCharCode;
var $ab15c74af972d349$export$e6e34fd1f2686227 = Object.assign;
function $ab15c74af972d349$export$d6af199866bfb566(e, r) {
    return $ab15c74af972d349$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $ab15c74af972d349$export$a9db5e087081082d(e, 0)) << 2 ^ $ab15c74af972d349$export$a9db5e087081082d(e, 1)) << 2 ^ $ab15c74af972d349$export$a9db5e087081082d(e, 2)) << 2 ^ $ab15c74af972d349$export$a9db5e087081082d(e, 3) : 0;
}
function $ab15c74af972d349$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $ab15c74af972d349$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $ab15c74af972d349$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $ab15c74af972d349$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $ab15c74af972d349$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $ab15c74af972d349$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $ab15c74af972d349$export$36776f635604f274(e) {
    return e.length;
}
function $ab15c74af972d349$export$f9084667e487ed46(e) {
    return e.length;
}
function $ab15c74af972d349$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $ab15c74af972d349$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $ab15c74af972d349$export$53f1d5ea8de3d7c = 1;
var $ab15c74af972d349$export$4e0c71f277ca26b3 = 1;
var $ab15c74af972d349$export$f24224f1c91d8156 = 0;
var $ab15c74af972d349$export$5880b8b5730aff45 = 0;
var $ab15c74af972d349$export$c0306caf338ac095 = 0;
var $ab15c74af972d349$export$30a86d91af8ff6e6 = "";
function $ab15c74af972d349$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $ab15c74af972d349$export$53f1d5ea8de3d7c,
        column: $ab15c74af972d349$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $ab15c74af972d349$export$784d13d8ee351f07(e, r) {
    return $ab15c74af972d349$export$e6e34fd1f2686227($ab15c74af972d349$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $ab15c74af972d349$export$eba6f6f03b0a92e7() {
    return $ab15c74af972d349$export$c0306caf338ac095;
}
function $ab15c74af972d349$export$232faf9add678146() {
    $ab15c74af972d349$export$c0306caf338ac095 = $ab15c74af972d349$export$5880b8b5730aff45 > 0 ? $ab15c74af972d349$export$a9db5e087081082d($ab15c74af972d349$export$30a86d91af8ff6e6, --$ab15c74af972d349$export$5880b8b5730aff45) : 0;
    if ($ab15c74af972d349$export$4e0c71f277ca26b3--, $ab15c74af972d349$export$c0306caf338ac095 === 10) $ab15c74af972d349$export$4e0c71f277ca26b3 = 1, $ab15c74af972d349$export$53f1d5ea8de3d7c--;
    return $ab15c74af972d349$export$c0306caf338ac095;
}
function $ab15c74af972d349$export$48cfd1e771a65c4f() {
    $ab15c74af972d349$export$c0306caf338ac095 = $ab15c74af972d349$export$5880b8b5730aff45 < $ab15c74af972d349$export$f24224f1c91d8156 ? $ab15c74af972d349$export$a9db5e087081082d($ab15c74af972d349$export$30a86d91af8ff6e6, $ab15c74af972d349$export$5880b8b5730aff45++) : 0;
    if ($ab15c74af972d349$export$4e0c71f277ca26b3++, $ab15c74af972d349$export$c0306caf338ac095 === 10) $ab15c74af972d349$export$4e0c71f277ca26b3 = 1, $ab15c74af972d349$export$53f1d5ea8de3d7c++;
    return $ab15c74af972d349$export$c0306caf338ac095;
}
function $ab15c74af972d349$export$4d3fb11e950abb9e() {
    return $ab15c74af972d349$export$a9db5e087081082d($ab15c74af972d349$export$30a86d91af8ff6e6, $ab15c74af972d349$export$5880b8b5730aff45);
}
function $ab15c74af972d349$export$e88cb2efb12ae807() {
    return $ab15c74af972d349$export$5880b8b5730aff45;
}
function $ab15c74af972d349$export$58adb3bec8346d0f(e, r) {
    return $ab15c74af972d349$export$2f35ab04d2335697($ab15c74af972d349$export$30a86d91af8ff6e6, e, r);
}
function $ab15c74af972d349$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $ab15c74af972d349$export$2de70f21292aac9e(e) {
    return $ab15c74af972d349$export$53f1d5ea8de3d7c = $ab15c74af972d349$export$4e0c71f277ca26b3 = 1, $ab15c74af972d349$export$f24224f1c91d8156 = $ab15c74af972d349$export$36776f635604f274($ab15c74af972d349$export$30a86d91af8ff6e6 = e), $ab15c74af972d349$export$5880b8b5730aff45 = 0, [];
}
function $ab15c74af972d349$export$45918ac1574455b1(e) {
    return $ab15c74af972d349$export$30a86d91af8ff6e6 = "", e;
}
function $ab15c74af972d349$export$410ac95b9ec204b8(e) {
    return $ab15c74af972d349$export$87c2784dc9fc4ab($ab15c74af972d349$export$58adb3bec8346d0f($ab15c74af972d349$export$5880b8b5730aff45 - 1, $ab15c74af972d349$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $ab15c74af972d349$export$660b2ee2d4fb4eff(e) {
    return $ab15c74af972d349$export$45918ac1574455b1($ab15c74af972d349$export$5f8c09e3ae6f64e1($ab15c74af972d349$export$2de70f21292aac9e(e)));
}
function $ab15c74af972d349$export$7af1228ff777d175(e) {
    while($ab15c74af972d349$export$c0306caf338ac095 = $ab15c74af972d349$export$4d3fb11e950abb9e())if ($ab15c74af972d349$export$c0306caf338ac095 < 33) $ab15c74af972d349$export$48cfd1e771a65c4f();
    else break;
    return $ab15c74af972d349$export$9e1725a4cfeada27(e) > 2 || $ab15c74af972d349$export$9e1725a4cfeada27($ab15c74af972d349$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $ab15c74af972d349$export$5f8c09e3ae6f64e1(e) {
    while($ab15c74af972d349$export$48cfd1e771a65c4f())switch($ab15c74af972d349$export$9e1725a4cfeada27($ab15c74af972d349$export$c0306caf338ac095)){
        case 0:
            $ab15c74af972d349$export$10d8903dec122b9d($ab15c74af972d349$export$c2ab62c7bf24634($ab15c74af972d349$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $ab15c74af972d349$export$10d8903dec122b9d($ab15c74af972d349$export$410ac95b9ec204b8($ab15c74af972d349$export$c0306caf338ac095), e);
            break;
        default:
            $ab15c74af972d349$export$10d8903dec122b9d($ab15c74af972d349$export$6788812c4e6611e6($ab15c74af972d349$export$c0306caf338ac095), e);
    }
    return e;
}
function $ab15c74af972d349$export$955ba06d119e085e(e, r) {
    while(--r && $ab15c74af972d349$export$48cfd1e771a65c4f())if ($ab15c74af972d349$export$c0306caf338ac095 < 48 || $ab15c74af972d349$export$c0306caf338ac095 > 102 || $ab15c74af972d349$export$c0306caf338ac095 > 57 && $ab15c74af972d349$export$c0306caf338ac095 < 65 || $ab15c74af972d349$export$c0306caf338ac095 > 70 && $ab15c74af972d349$export$c0306caf338ac095 < 97) break;
    return $ab15c74af972d349$export$58adb3bec8346d0f(e, $ab15c74af972d349$export$e88cb2efb12ae807() + (r < 6 && $ab15c74af972d349$export$4d3fb11e950abb9e() == 32 && $ab15c74af972d349$export$48cfd1e771a65c4f() == 32));
}
function $ab15c74af972d349$export$c889f2fcc19dbf12(e) {
    while($ab15c74af972d349$export$48cfd1e771a65c4f())switch($ab15c74af972d349$export$c0306caf338ac095){
        case e:
            return $ab15c74af972d349$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $ab15c74af972d349$export$c889f2fcc19dbf12($ab15c74af972d349$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $ab15c74af972d349$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $ab15c74af972d349$export$48cfd1e771a65c4f();
            break;
    }
    return $ab15c74af972d349$export$5880b8b5730aff45;
}
function $ab15c74af972d349$export$4254d4e2b3745c4c(e, r) {
    while($ab15c74af972d349$export$48cfd1e771a65c4f())if (e + $ab15c74af972d349$export$c0306caf338ac095 === 57) break;
    else if (e + $ab15c74af972d349$export$c0306caf338ac095 === 84 && $ab15c74af972d349$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $ab15c74af972d349$export$58adb3bec8346d0f(r, $ab15c74af972d349$export$5880b8b5730aff45 - 1) + "*" + $ab15c74af972d349$export$6788812c4e6611e6(e === 47 ? e : $ab15c74af972d349$export$48cfd1e771a65c4f());
}
function $ab15c74af972d349$export$c2ab62c7bf24634(e) {
    while(!$ab15c74af972d349$export$9e1725a4cfeada27($ab15c74af972d349$export$4d3fb11e950abb9e()))$ab15c74af972d349$export$48cfd1e771a65c4f();
    return $ab15c74af972d349$export$58adb3bec8346d0f(e, $ab15c74af972d349$export$5880b8b5730aff45);
}
function $ab15c74af972d349$export$ef7acd7185315e22(e) {
    return $ab15c74af972d349$export$45918ac1574455b1($ab15c74af972d349$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $ab15c74af972d349$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $ab15c74af972d349$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $ab15c74af972d349$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $ab15c74af972d349$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($ab15c74af972d349$export$f8e21b1e77979a08(j += $ab15c74af972d349$export$77ad94ebf1c2b9ed($ab15c74af972d349$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $ab15c74af972d349$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $ab15c74af972d349$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $ab15c74af972d349$export$955ba06d119e085e($ab15c74af972d349$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($ab15c74af972d349$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $ab15c74af972d349$export$10d8903dec122b9d($ab15c74af972d349$export$4a34f930e789283c($ab15c74af972d349$export$4254d4e2b3745c4c($ab15c74af972d349$export$48cfd1e771a65c4f(), $ab15c74af972d349$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $ab15c74af972d349$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $ab15c74af972d349$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $ab15c74af972d349$export$36776f635604f274(j) - l) $ab15c74af972d349$export$10d8903dec122b9d(p > 32 ? $ab15c74af972d349$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $ab15c74af972d349$export$f8483753829ec8f3($ab15c74af972d349$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $ab15c74af972d349$export$10d8903dec122b9d(y = $ab15c74af972d349$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $ab15c74af972d349$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $ab15c74af972d349$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $ab15c74af972d349$export$98e6a39c04603d36(e, y, y, n && $ab15c74af972d349$export$10d8903dec122b9d($ab15c74af972d349$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $ab15c74af972d349$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $ab15c74af972d349$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $ab15c74af972d349$export$232faf9add678146() == 125) continue;
            }
            switch(j += $ab15c74af972d349$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($ab15c74af972d349$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($ab15c74af972d349$export$4d3fb11e950abb9e() === 45) j += $ab15c74af972d349$export$410ac95b9ec204b8($ab15c74af972d349$export$48cfd1e771a65c4f());
                    v = $ab15c74af972d349$export$4d3fb11e950abb9e(), o = l = $ab15c74af972d349$export$36776f635604f274(g = j += $ab15c74af972d349$export$c2ab62c7bf24634($ab15c74af972d349$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $ab15c74af972d349$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $ab15c74af972d349$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $ab15c74af972d349$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $ab15c74af972d349$export$2f35ab04d2335697(e, v + 1, v = $ab15c74af972d349$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $ab15c74af972d349$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $ab15c74af972d349$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $ab15c74af972d349$export$35059013cd4a06db(e, r, a, s === 0 ? $ab15c74af972d349$export$aa3a2e812ca8570d : i, f, o, l);
}
function $ab15c74af972d349$export$4a34f930e789283c(e, r, a) {
    return $ab15c74af972d349$export$35059013cd4a06db(e, r, a, $ab15c74af972d349$export$a29989082612d0d9, $ab15c74af972d349$export$6788812c4e6611e6($ab15c74af972d349$export$eba6f6f03b0a92e7()), $ab15c74af972d349$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $ab15c74af972d349$export$f8483753829ec8f3(e, r, a, n) {
    return $ab15c74af972d349$export$35059013cd4a06db(e, r, a, $ab15c74af972d349$export$527d108ccf083c2b, $ab15c74af972d349$export$2f35ab04d2335697(e, 0, n), $ab15c74af972d349$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $ab15c74af972d349$export$82e9f45cca5ba907(n, c, s) {
    switch($ab15c74af972d349$export$d6af199866bfb566(n, c)){
        case 5103:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $ab15c74af972d349$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$2c0f367103c8d01c + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($ab15c74af972d349$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $ab15c74af972d349$export$39dfd62a25e0fe93 + "box-$1$2" + $ab15c74af972d349$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + "flex-item-" + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$ab15c74af972d349$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $ab15c74af972d349$export$71ad59f2e432cfe8 + "grid-row-" + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + "flex-line-pack" + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + "box-" + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "-grow", "") + $ab15c74af972d349$export$39dfd62a25e0fe93 + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $ab15c74af972d349$export$39dfd62a25e0fe93 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $ab15c74af972d349$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $ab15c74af972d349$export$77ad94ebf1c2b9ed($ab15c74af972d349$export$77ad94ebf1c2b9ed($ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $ab15c74af972d349$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $ab15c74af972d349$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $ab15c74af972d349$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $ab15c74af972d349$export$77ad94ebf1c2b9ed($ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $ab15c74af972d349$export$39dfd62a25e0fe93 + "box-pack:$3" + $ab15c74af972d349$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $ab15c74af972d349$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$ab15c74af972d349$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $ab15c74af972d349$export$71ad59f2e432cfe8 + "grid-column-align" + $ab15c74af972d349$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $ab15c74af972d349$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$ab15c74af972d349$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $ab15c74af972d349$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$ab15c74af972d349$export$f8e21b1e77979a08(s, "span") ? $ab15c74af972d349$export$4659b591c19bdf3d(s, /\d+/) : +$ab15c74af972d349$export$4659b591c19bdf3d(s, /\d+/) - +$ab15c74af972d349$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $ab15c74af972d349$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $ab15c74af972d349$export$71ad59f2e432cfe8 + $ab15c74af972d349$export$77ad94ebf1c2b9ed($ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $ab15c74af972d349$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($ab15c74af972d349$export$36776f635604f274(n) - 1 - c > 6) switch($ab15c74af972d349$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($ab15c74af972d349$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $ab15c74af972d349$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $ab15c74af972d349$export$2c0f367103c8d01c + ($ab15c74af972d349$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$ab15c74af972d349$export$f8e21b1e77979a08(n, "stretch") ? $ab15c74af972d349$export$82e9f45cca5ba907($ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $ab15c74af972d349$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $ab15c74af972d349$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($ab15c74af972d349$export$a9db5e087081082d(n, c + 6) === 121) return $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, ":", ":" + $ab15c74af972d349$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($ab15c74af972d349$export$a9db5e087081082d(n, $ab15c74af972d349$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $ab15c74af972d349$export$39dfd62a25e0fe93 + ($ab15c74af972d349$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $ab15c74af972d349$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $ab15c74af972d349$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, ":", ":" + $ab15c74af972d349$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $ab15c74af972d349$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $ab15c74af972d349$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $ab15c74af972d349$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $ab15c74af972d349$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $ab15c74af972d349$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $ab15c74af972d349$export$a763edbf796b780a:
        case $ab15c74af972d349$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $ab15c74af972d349$export$a29989082612d0d9:
            return "";
        case $ab15c74af972d349$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $ab15c74af972d349$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $ab15c74af972d349$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $ab15c74af972d349$export$36776f635604f274(a = $ab15c74af972d349$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $ab15c74af972d349$export$5a7767152ae0305f(e) {
    var r = $ab15c74af972d349$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $ab15c74af972d349$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $ab15c74af972d349$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $ab15c74af972d349$export$527d108ccf083c2b:
                n.return = $ab15c74af972d349$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $ab15c74af972d349$export$b44a8529a35fcb60:
                return $ab15c74af972d349$export$dfdc1655ccc5b9cb([
                    $ab15c74af972d349$export$784d13d8ee351f07(n, {
                        value: $ab15c74af972d349$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $ab15c74af972d349$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $ab15c74af972d349$export$aa3a2e812ca8570d:
                if (n.length) return $ab15c74af972d349$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($ab15c74af972d349$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $ab15c74af972d349$export$dfdc1655ccc5b9cb([
                                $ab15c74af972d349$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ab15c74af972d349$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $ab15c74af972d349$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $ab15c74af972d349$export$dfdc1655ccc5b9cb([
                                $ab15c74af972d349$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ab15c74af972d349$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $ab15c74af972d349$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $ab15c74af972d349$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ab15c74af972d349$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $ab15c74af972d349$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $ab15c74af972d349$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ab15c74af972d349$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $ab15c74af972d349$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $ab15c74af972d349$export$76a88f7de6507443(e) {
    switch(e.type){
        case $ab15c74af972d349$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $ab15c74af972d349$export$1be1fc439b849fdf($ab15c74af972d349$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($ab15c74af972d349$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $ab15c74af972d349$export$2f35ab04d2335697(r, 1, $ab15c74af972d349$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $ab15c74af972d349$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $ab15c74af972d349$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $ab15c74af972d349$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("jAslQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4275f19a7a80979$export$2e2bcd8739ae039; });
var $e4275f19a7a80979$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("5HZ86", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $428063029556e8f2$export$2e2bcd8739ae039; });
function $428063029556e8f2$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("3dgiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $256f3a93f30eef79$export$2e2bcd8739ae039; });

var $movFX = parcelRequire("movFX");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $256f3a93f30eef79$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($movFX)))(targetComponent, sourceComponent);
};

});

parcelRegister("fhXxk", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $02df552a7e0b45c0$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $02df552a7e0b45c0$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $02df552a7e0b45c0$export$6f077d94b33a01aa; });
var $02df552a7e0b45c0$var$isBrowser = typeof document !== "undefined";
function $02df552a7e0b45c0$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $02df552a7e0b45c0$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $02df552a7e0b45c0$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $02df552a7e0b45c0$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $02df552a7e0b45c0$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$02df552a7e0b45c0$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$02df552a7e0b45c0$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8OpE1", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $66a6e2b0a97526d4$export$6321afa313b251b5; });

var $lHOaH = parcelRequire("lHOaH");

var $hExAA = parcelRequire("hExAA");

var $5HZ86 = parcelRequire("5HZ86");
var $66a6e2b0a97526d4$var$isDevelopment = false;
var $66a6e2b0a97526d4$var$hyphenateRegex = /[A-Z]|^ms/g;
var $66a6e2b0a97526d4$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $66a6e2b0a97526d4$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $66a6e2b0a97526d4$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $66a6e2b0a97526d4$var$processStyleName = /* #__PURE__ */ (0, $5HZ86.default)(function(styleName) {
    return $66a6e2b0a97526d4$var$isCustomProperty(styleName) ? styleName : styleName.replace($66a6e2b0a97526d4$var$hyphenateRegex, "-$&").toLowerCase();
});
var $66a6e2b0a97526d4$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($66a6e2b0a97526d4$var$animationRegex, function(match, p1, p2) {
                $66a6e2b0a97526d4$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $66a6e2b0a97526d4$var$cursor
                };
                return p1;
            });
    }
    if ((0, $hExAA.default)[key] !== 1 && !$66a6e2b0a97526d4$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $66a6e2b0a97526d4$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $66a6e2b0a97526d4$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $66a6e2b0a97526d4$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $66a6e2b0a97526d4$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $66a6e2b0a97526d4$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $66a6e2b0a97526d4$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $66a6e2b0a97526d4$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $66a6e2b0a97526d4$var$cursor;
                var result = interpolation(mergedProps);
                $66a6e2b0a97526d4$var$cursor = previousCursor;
                return $66a6e2b0a97526d4$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $66a6e2b0a97526d4$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $66a6e2b0a97526d4$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($66a6e2b0a97526d4$var$isProcessableValue(asString)) string += $66a6e2b0a97526d4$var$processStyleName(key) + ":" + $66a6e2b0a97526d4$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $66a6e2b0a97526d4$var$isDevelopment) throw new Error($66a6e2b0a97526d4$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($66a6e2b0a97526d4$var$isProcessableValue(value[_i])) string += $66a6e2b0a97526d4$var$processStyleName(key) + ":" + $66a6e2b0a97526d4$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $66a6e2b0a97526d4$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $66a6e2b0a97526d4$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $66a6e2b0a97526d4$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $66a6e2b0a97526d4$var$cursor;
function $66a6e2b0a97526d4$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $66a6e2b0a97526d4$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $66a6e2b0a97526d4$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $66a6e2b0a97526d4$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $66a6e2b0a97526d4$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $66a6e2b0a97526d4$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $lHOaH.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $66a6e2b0a97526d4$var$cursor
    };
}

});
parcelRegister("lHOaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcd4882464750471$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $fcd4882464750471$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("hExAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cda03a2a9efd13fc$export$2e2bcd8739ae039; });
var $cda03a2a9efd13fc$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("hwSOa", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $cc2ff09481bf3ad2$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $cc2ff09481bf3ad2$export$811a713a7276cb9d; });

var $gOovR = parcelRequire("gOovR");
var $cc2ff09481bf3ad2$var$isBrowser = typeof document !== "undefined";
var $cc2ff09481bf3ad2$var$syncFallback = function syncFallback(create) {
    return create();
};
var $cc2ff09481bf3ad2$var$useInsertionEffect = $gOovR.useInsertionEffect ? $gOovR.useInsertionEffect : false;
var $cc2ff09481bf3ad2$export$db21c7ffa21794e7 = !$cc2ff09481bf3ad2$var$isBrowser ? $cc2ff09481bf3ad2$var$syncFallback : $cc2ff09481bf3ad2$var$useInsertionEffect || $cc2ff09481bf3ad2$var$syncFallback;
var $cc2ff09481bf3ad2$export$811a713a7276cb9d = $cc2ff09481bf3ad2$var$useInsertionEffect || $gOovR.useLayoutEffect;

});


parcelRegister("5WRll", function(module, exports) {
function $454bbf648c173333$var$_extends() {
    return module.exports = $454bbf648c173333$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $454bbf648c173333$var$_extends.apply(null, arguments);
}
module.exports = $454bbf648c173333$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cimYz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f38fd07997d380b$export$2e2bcd8739ae039; });
function $8f38fd07997d380b$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("6T9M7", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $503f7642b86ddc73$export$deee3a793edee05f; });

var $iFE7c = parcelRequire("iFE7c");
var $abV13 = parcelRequire("abV13");

var $abV13 = parcelRequire("abV13");

var $4IHrW = parcelRequire("4IHrW");
function $503f7642b86ddc73$var$getCssDimensions(element) {
    const css = (0, $4IHrW.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $4IHrW.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $abV13.round)(width) !== offsetWidth || (0, $abV13.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $503f7642b86ddc73$var$unwrapElement(element) {
    return !(0, $4IHrW.isElement)(element) ? element.contextElement : element;
}
function $503f7642b86ddc73$var$getScale(element) {
    const domElement = $503f7642b86ddc73$var$unwrapElement(element);
    if (!(0, $4IHrW.isHTMLElement)(domElement)) return (0, $abV13.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $503f7642b86ddc73$var$getCssDimensions(domElement);
    let x = ($ ? (0, $abV13.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $abV13.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $503f7642b86ddc73$var$noOffsets = /*#__PURE__*/ (0, $abV13.createCoords)(0);
function $503f7642b86ddc73$var$getVisualOffsets(element) {
    const win = (0, $4IHrW.getWindow)(element);
    if (!(0, $4IHrW.isWebKit)() || !win.visualViewport) return $503f7642b86ddc73$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $503f7642b86ddc73$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $4IHrW.getWindow)(element)) return false;
    return isFixed;
}
function $503f7642b86ddc73$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $503f7642b86ddc73$var$unwrapElement(element);
    let scale = (0, $abV13.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $4IHrW.isElement)(offsetParent)) scale = $503f7642b86ddc73$var$getScale(offsetParent);
        } else scale = $503f7642b86ddc73$var$getScale(element);
    }
    const visualOffsets = $503f7642b86ddc73$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $503f7642b86ddc73$var$getVisualOffsets(domElement) : (0, $abV13.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $4IHrW.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $4IHrW.isElement)(offsetParent) ? (0, $4IHrW.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $4IHrW.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $503f7642b86ddc73$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $4IHrW.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $4IHrW.getWindow)(currentIFrame);
            currentIFrame = (0, $4IHrW.getFrameElement)(currentWin);
        }
    }
    return (0, $abV13.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $503f7642b86ddc73$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $4IHrW.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $4IHrW.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $abV13.createCoords)(1);
    const offsets = (0, $abV13.createCoords)(0);
    const isOffsetParentAnElement = (0, $4IHrW.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4IHrW.getNodeName)(offsetParent) !== "body" || (0, $4IHrW.isOverflowElement)(documentElement)) scroll = (0, $4IHrW.getNodeScroll)(offsetParent);
        if ((0, $4IHrW.isHTMLElement)(offsetParent)) {
            const offsetRect = $503f7642b86ddc73$var$getBoundingClientRect(offsetParent);
            scale = $503f7642b86ddc73$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $503f7642b86ddc73$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $503f7642b86ddc73$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $4IHrW.getNodeScroll)(element).scrollLeft;
    if (!rect) return $503f7642b86ddc73$var$getBoundingClientRect((0, $4IHrW.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $503f7642b86ddc73$var$getDocumentRect(element) {
    const html = (0, $4IHrW.getDocumentElement)(element);
    const scroll = (0, $4IHrW.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $abV13.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $abV13.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $503f7642b86ddc73$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $4IHrW.getComputedStyle)(body).direction === "rtl") x += (0, $abV13.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $503f7642b86ddc73$var$getViewportRect(element, strategy) {
    const win = (0, $4IHrW.getWindow)(element);
    const html = (0, $4IHrW.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $4IHrW.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $503f7642b86ddc73$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $503f7642b86ddc73$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $4IHrW.isHTMLElement)(element) ? $503f7642b86ddc73$var$getScale(element) : (0, $abV13.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $503f7642b86ddc73$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $503f7642b86ddc73$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $503f7642b86ddc73$var$getDocumentRect((0, $4IHrW.getDocumentElement)(element));
    else if ((0, $4IHrW.isElement)(clippingAncestor)) rect = $503f7642b86ddc73$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $503f7642b86ddc73$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $abV13.rectToClientRect)(rect);
}
function $503f7642b86ddc73$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $4IHrW.getParentNode)(element);
    if (parentNode === stopNode || !(0, $4IHrW.isElement)(parentNode) || (0, $4IHrW.isLastTraversableNode)(parentNode)) return false;
    return (0, $4IHrW.getComputedStyle)(parentNode).position === "fixed" || $503f7642b86ddc73$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $503f7642b86ddc73$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $4IHrW.getOverflowAncestors)(element, [], false).filter((el)=>(0, $4IHrW.isElement)(el) && (0, $4IHrW.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $4IHrW.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $4IHrW.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $4IHrW.isElement)(currentNode) && !(0, $4IHrW.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $4IHrW.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $4IHrW.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $4IHrW.isOverflowElement)(currentNode) && !currentNodeIsContaining && $503f7642b86ddc73$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $4IHrW.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $503f7642b86ddc73$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $4IHrW.isTopLayer)(element) ? [] : $503f7642b86ddc73$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $503f7642b86ddc73$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $abV13.max)(rect.top, accRect.top);
        accRect.right = (0, $abV13.min)(rect.right, accRect.right);
        accRect.bottom = (0, $abV13.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $abV13.max)(rect.left, accRect.left);
        return accRect;
    }, $503f7642b86ddc73$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $503f7642b86ddc73$var$getDimensions(element) {
    const { width: width, height: height } = $503f7642b86ddc73$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $503f7642b86ddc73$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $4IHrW.isHTMLElement)(offsetParent);
    const documentElement = (0, $4IHrW.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $503f7642b86ddc73$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $abV13.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4IHrW.getNodeName)(offsetParent) !== "body" || (0, $4IHrW.isOverflowElement)(documentElement)) scroll = (0, $4IHrW.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $503f7642b86ddc73$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $503f7642b86ddc73$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $503f7642b86ddc73$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $503f7642b86ddc73$var$isStaticPositioned(element) {
    return (0, $4IHrW.getComputedStyle)(element).position === "static";
}
function $503f7642b86ddc73$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $4IHrW.isHTMLElement)(element) || (0, $4IHrW.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $4IHrW.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $503f7642b86ddc73$var$getOffsetParent(element, polyfill) {
    const win = (0, $4IHrW.getWindow)(element);
    if ((0, $4IHrW.isTopLayer)(element)) return win;
    if (!(0, $4IHrW.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $4IHrW.getParentNode)(element);
        while(svgOffsetParent && !(0, $4IHrW.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $4IHrW.isElement)(svgOffsetParent) && !$503f7642b86ddc73$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $4IHrW.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $503f7642b86ddc73$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $4IHrW.isTableElement)(offsetParent) && $503f7642b86ddc73$var$isStaticPositioned(offsetParent))offsetParent = $503f7642b86ddc73$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $4IHrW.isLastTraversableNode)(offsetParent) && $503f7642b86ddc73$var$isStaticPositioned(offsetParent) && !(0, $4IHrW.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $4IHrW.getContainingBlock)(element) || win;
}
const $503f7642b86ddc73$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $503f7642b86ddc73$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $503f7642b86ddc73$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $503f7642b86ddc73$var$isRTL(element) {
    return (0, $4IHrW.getComputedStyle)(element).direction === "rtl";
}
const $503f7642b86ddc73$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $503f7642b86ddc73$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $4IHrW.getDocumentElement,
    getClippingRect: $503f7642b86ddc73$var$getClippingRect,
    getOffsetParent: $503f7642b86ddc73$var$getOffsetParent,
    getElementRects: $503f7642b86ddc73$var$getElementRects,
    getClientRects: $503f7642b86ddc73$var$getClientRects,
    getDimensions: $503f7642b86ddc73$var$getDimensions,
    getScale: $503f7642b86ddc73$var$getScale,
    isElement: $4IHrW.isElement,
    isRTL: $503f7642b86ddc73$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $503f7642b86ddc73$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $4IHrW.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $abV13.floor)(top);
        const insetRight = (0, $abV13.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $abV13.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $abV13.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $abV13.max)(0, (0, $abV13.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $503f7642b86ddc73$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $503f7642b86ddc73$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $4IHrW.getOverflowAncestors)(referenceEl) : [],
        ...(0, $4IHrW.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $503f7642b86ddc73$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $503f7642b86ddc73$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $503f7642b86ddc73$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $503f7642b86ddc73$export$37b6bde19b108ecc = (0, $iFE7c.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $503f7642b86ddc73$export$cc800923e997bb8 = (0, $iFE7c.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $503f7642b86ddc73$export$91fb6ecbd551914 = (0, $iFE7c.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $503f7642b86ddc73$export$fba63a578e423eb = (0, $iFE7c.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $503f7642b86ddc73$export$8a83211c878a3f1f = (0, $iFE7c.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $503f7642b86ddc73$export$346677f925de839c = (0, $iFE7c.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $503f7642b86ddc73$export$fe8985bb6374093c = (0, $iFE7c.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $503f7642b86ddc73$export$f2120bbfa5450bd2 = (0, $iFE7c.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $503f7642b86ddc73$export$18c8ad048e32c7d5 = (0, $iFE7c.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $503f7642b86ddc73$export$7bf07e38f3dc4b69 = (0, $iFE7c.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $503f7642b86ddc73$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $503f7642b86ddc73$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $iFE7c.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("iFE7c", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $d97b2c55ddb6244b$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $d97b2c55ddb6244b$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $d97b2c55ddb6244b$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $d97b2c55ddb6244b$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $d97b2c55ddb6244b$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $d97b2c55ddb6244b$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $d97b2c55ddb6244b$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $d97b2c55ddb6244b$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $d97b2c55ddb6244b$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $d97b2c55ddb6244b$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $d97b2c55ddb6244b$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("abV13")).rectToClientRect; });

var $abV13 = parcelRequire("abV13");
function $d97b2c55ddb6244b$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $abV13.getSideAxis)(placement);
    const alignmentAxis = (0, $abV13.getAlignmentAxis)(placement);
    const alignLength = (0, $abV13.getAxisLength)(alignmentAxis);
    const side = (0, $abV13.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $abV13.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $d97b2c55ddb6244b$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $d97b2c55ddb6244b$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $d97b2c55ddb6244b$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $d97b2c55ddb6244b$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $abV13.evaluate)(options, state);
    const paddingObject = (0, $abV13.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $abV13.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $abV13.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $d97b2c55ddb6244b$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $abV13.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $abV13.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $abV13.getAlignmentAxis)(placement);
            const length = (0, $abV13.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $abV13.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $abV13.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $abV13.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $abV13.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $d97b2c55ddb6244b$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $abV13.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $abV13.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $abV13.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $abV13.getAlignment)(placement) === alignment || (autoAlignment ? (0, $abV13.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $d97b2c55ddb6244b$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $abV13.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $abV13.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $abV13.placements) ? $d97b2c55ddb6244b$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $d97b2c55ddb6244b$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $abV13.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $abV13.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $abV13.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $abV13.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $d97b2c55ddb6244b$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $abV13.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $abV13.getSide)(placement);
            const initialSideAxis = (0, $abV13.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $abV13.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $abV13.getOppositePlacement)(initialPlacement)
            ] : (0, $abV13.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $abV13.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $d97b2c55ddb6244b$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $abV13.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $abV13.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $d97b2c55ddb6244b$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $d97b2c55ddb6244b$var$isAnySideFullyClipped(overflow) {
    return (0, $abV13.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $d97b2c55ddb6244b$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $abV13.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $d97b2c55ddb6244b$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $d97b2c55ddb6244b$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $d97b2c55ddb6244b$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $d97b2c55ddb6244b$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $d97b2c55ddb6244b$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $d97b2c55ddb6244b$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $d97b2c55ddb6244b$var$getBoundingRect(rects) {
    const minX = (0, $abV13.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $abV13.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $abV13.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $abV13.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $d97b2c55ddb6244b$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $abV13.rectToClientRect)($d97b2c55ddb6244b$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $d97b2c55ddb6244b$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $abV13.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $d97b2c55ddb6244b$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $abV13.rectToClientRect)($d97b2c55ddb6244b$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $abV13.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $abV13.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $abV13.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $abV13.getSide)(placement) === "left";
                    const maxRight = (0, $abV13.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $abV13.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $d97b2c55ddb6244b$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $abV13.getSide)(placement);
    const alignment = (0, $abV13.getAlignment)(placement);
    const isVertical = (0, $abV13.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $abV13.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $d97b2c55ddb6244b$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $d97b2c55ddb6244b$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $d97b2c55ddb6244b$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $abV13.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $d97b2c55ddb6244b$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $abV13.getSideAxis)((0, $abV13.getSide)(placement));
            const mainAxis = (0, $abV13.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $abV13.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $abV13.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $d97b2c55ddb6244b$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $abV13.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $abV13.getSideAxis)(placement);
            const mainAxis = (0, $abV13.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $abV13.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $abV13.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $d97b2c55ddb6244b$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $abV13.evaluate)(options, state);
            const overflow = await $d97b2c55ddb6244b$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $abV13.getSide)(placement);
            const alignment = (0, $abV13.getAlignment)(placement);
            const isYAxis = (0, $abV13.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $abV13.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $abV13.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $abV13.max)(overflow.left, 0);
                const xMax = (0, $abV13.max)(overflow.right, 0);
                const yMin = (0, $abV13.max)(overflow.top, 0);
                const yMax = (0, $abV13.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $abV13.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $abV13.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("abV13", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $76b728a3a8aa110b$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $76b728a3a8aa110b$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $76b728a3a8aa110b$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $76b728a3a8aa110b$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $76b728a3a8aa110b$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $76b728a3a8aa110b$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $76b728a3a8aa110b$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $76b728a3a8aa110b$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $76b728a3a8aa110b$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $76b728a3a8aa110b$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $76b728a3a8aa110b$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $76b728a3a8aa110b$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $76b728a3a8aa110b$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $76b728a3a8aa110b$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $76b728a3a8aa110b$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $76b728a3a8aa110b$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $76b728a3a8aa110b$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $76b728a3a8aa110b$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $76b728a3a8aa110b$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $76b728a3a8aa110b$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $76b728a3a8aa110b$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $76b728a3a8aa110b$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $76b728a3a8aa110b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $76b728a3a8aa110b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $76b728a3a8aa110b$export$803cd8101b6c182b = /*#__PURE__*/ $76b728a3a8aa110b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $76b728a3a8aa110b$export$27b07d8a310ed8b5[0], side + "-" + $76b728a3a8aa110b$export$27b07d8a310ed8b5[1]), []);
const $76b728a3a8aa110b$export$96ec731ed4dcb222 = Math.min;
const $76b728a3a8aa110b$export$8960430cfd85939f = Math.max;
const $76b728a3a8aa110b$export$2077e0241d6afd3c = Math.round;
const $76b728a3a8aa110b$export$a3fe094919f356fd = Math.floor;
const $76b728a3a8aa110b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $76b728a3a8aa110b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $76b728a3a8aa110b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $76b728a3a8aa110b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $76b728a3a8aa110b$export$8960430cfd85939f(start, $76b728a3a8aa110b$export$96ec731ed4dcb222(value, end));
}
function $76b728a3a8aa110b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $76b728a3a8aa110b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $76b728a3a8aa110b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $76b728a3a8aa110b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $76b728a3a8aa110b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $76b728a3a8aa110b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($76b728a3a8aa110b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $76b728a3a8aa110b$export$2b57e0052a6d6d4c(placement) {
    return $76b728a3a8aa110b$export$8a000a963141ac32($76b728a3a8aa110b$export$f28e8f882010718a(placement));
}
function $76b728a3a8aa110b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $76b728a3a8aa110b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $76b728a3a8aa110b$export$2b57e0052a6d6d4c(placement);
    const length = $76b728a3a8aa110b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $76b728a3a8aa110b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $76b728a3a8aa110b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $76b728a3a8aa110b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $76b728a3a8aa110b$export$9c5e28bad23365fa(placement);
    return [
        $76b728a3a8aa110b$export$2b182c584985588b(placement),
        oppositePlacement,
        $76b728a3a8aa110b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $76b728a3a8aa110b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$76b728a3a8aa110b$var$oppositeAlignmentMap[alignment]);
}
function $76b728a3a8aa110b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $76b728a3a8aa110b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $76b728a3a8aa110b$export$f0989780f32bfcda(placement);
    let list = $76b728a3a8aa110b$var$getSideList($76b728a3a8aa110b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($76b728a3a8aa110b$export$2b182c584985588b));
    }
    return list;
}
function $76b728a3a8aa110b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$76b728a3a8aa110b$var$oppositeSideMap[side]);
}
function $76b728a3a8aa110b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $76b728a3a8aa110b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $76b728a3a8aa110b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $76b728a3a8aa110b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("4IHrW", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $36fcf9b062c4cbd8$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $36fcf9b062c4cbd8$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $36fcf9b062c4cbd8$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $36fcf9b062c4cbd8$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $36fcf9b062c4cbd8$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $36fcf9b062c4cbd8$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $36fcf9b062c4cbd8$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $36fcf9b062c4cbd8$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $36fcf9b062c4cbd8$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $36fcf9b062c4cbd8$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $36fcf9b062c4cbd8$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $36fcf9b062c4cbd8$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $36fcf9b062c4cbd8$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $36fcf9b062c4cbd8$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $36fcf9b062c4cbd8$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $36fcf9b062c4cbd8$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $36fcf9b062c4cbd8$export$7bf1f8740e3e34af; });
function $36fcf9b062c4cbd8$var$hasWindow() {
    return typeof window !== "undefined";
}
function $36fcf9b062c4cbd8$export$651544f548703224(node) {
    if ($36fcf9b062c4cbd8$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $36fcf9b062c4cbd8$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $36fcf9b062c4cbd8$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($36fcf9b062c4cbd8$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $36fcf9b062c4cbd8$export$8ee0fc9ee280b4ee(value) {
    if (!$36fcf9b062c4cbd8$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $36fcf9b062c4cbd8$export$38b2d434cce3ea22(value).Node;
}
function $36fcf9b062c4cbd8$export$45a5e7f76e0caa8d(value) {
    if (!$36fcf9b062c4cbd8$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $36fcf9b062c4cbd8$export$38b2d434cce3ea22(value).Element;
}
function $36fcf9b062c4cbd8$export$1b3bfaa9684536aa(value) {
    if (!$36fcf9b062c4cbd8$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $36fcf9b062c4cbd8$export$38b2d434cce3ea22(value).HTMLElement;
}
function $36fcf9b062c4cbd8$export$af51f0f06c0f328a(value) {
    if (!$36fcf9b062c4cbd8$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $36fcf9b062c4cbd8$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $36fcf9b062c4cbd8$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $36fcf9b062c4cbd8$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $36fcf9b062c4cbd8$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($36fcf9b062c4cbd8$export$651544f548703224(element));
}
function $36fcf9b062c4cbd8$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $36fcf9b062c4cbd8$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $36fcf9b062c4cbd8$export$78551043582a6a98();
    const css = $36fcf9b062c4cbd8$export$45a5e7f76e0caa8d(elementOrCss) ? $36fcf9b062c4cbd8$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $36fcf9b062c4cbd8$export$940d8225183e1404(element) {
    let currentNode = $36fcf9b062c4cbd8$export$4e12058fc4d51d56(element);
    while($36fcf9b062c4cbd8$export$1b3bfaa9684536aa(currentNode) && !$36fcf9b062c4cbd8$export$d1162fb0b6d4cd51(currentNode)){
        if ($36fcf9b062c4cbd8$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($36fcf9b062c4cbd8$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $36fcf9b062c4cbd8$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $36fcf9b062c4cbd8$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $36fcf9b062c4cbd8$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($36fcf9b062c4cbd8$export$651544f548703224(node));
}
function $36fcf9b062c4cbd8$export$3735103072e4a80(element) {
    return $36fcf9b062c4cbd8$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $36fcf9b062c4cbd8$export$dc8fc79fa2800137(element) {
    if ($36fcf9b062c4cbd8$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $36fcf9b062c4cbd8$export$4e12058fc4d51d56(node) {
    if ($36fcf9b062c4cbd8$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $36fcf9b062c4cbd8$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $36fcf9b062c4cbd8$export$e495491855dc5418(node);
    return $36fcf9b062c4cbd8$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $36fcf9b062c4cbd8$export$7cd01a57c8ca906c(node) {
    const parentNode = $36fcf9b062c4cbd8$export$4e12058fc4d51d56(node);
    if ($36fcf9b062c4cbd8$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($36fcf9b062c4cbd8$export$1b3bfaa9684536aa(parentNode) && $36fcf9b062c4cbd8$export$989e911fa9af580a(parentNode)) return parentNode;
    return $36fcf9b062c4cbd8$export$7cd01a57c8ca906c(parentNode);
}
function $36fcf9b062c4cbd8$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $36fcf9b062c4cbd8$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $36fcf9b062c4cbd8$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $36fcf9b062c4cbd8$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $36fcf9b062c4cbd8$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $36fcf9b062c4cbd8$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $36fcf9b062c4cbd8$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $36fcf9b062c4cbd8$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("aoLZt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79215f314683d532$export$2e2bcd8739ae039; });

var $gOovR = parcelRequire("gOovR");
var $79215f314683d532$var$index = (0, $gOovR.useLayoutEffect);
var $79215f314683d532$export$2e2bcd8739ae039 = $79215f314683d532$var$index;

});


parcelRegister("dLDsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a05e46ca0b3d6cbc$export$2e2bcd8739ae039; });
var $a05e46ca0b3d6cbc$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $a05e46ca0b3d6cbc$var$isEqual(first, second) {
    if (first === second) return true;
    if ($a05e46ca0b3d6cbc$var$safeIsNaN(first) && $a05e46ca0b3d6cbc$var$safeIsNaN(second)) return true;
    return false;
}
function $a05e46ca0b3d6cbc$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$a05e46ca0b3d6cbc$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $a05e46ca0b3d6cbc$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $a05e46ca0b3d6cbc$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("a9Eub", function(module, exports) {

var $iYS30 = parcelRequire("iYS30");
function $764a264ca66baa2d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $764a264ca66baa2d$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $764a264ca66baa2d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $iYS30(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $764a264ca66baa2d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $764a264ca66baa2d$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iYS30", function(module, exports) {

var $kRJF5 = parcelRequire("kRJF5");
function $dd17c14e3d746776$var$_defineProperty(e, r, t) {
    return (r = $kRJF5(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $dd17c14e3d746776$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kRJF5", function(module, exports) {

var $bnuVp = parcelRequire("bnuVp");
var $f30c2d593537cf37$var$_typeof = $bnuVp.default;

var $8G9Tg = parcelRequire("8G9Tg");
function $f30c2d593537cf37$var$toPropertyKey(t) {
    var i = $8G9Tg(t, "string");
    return "symbol" == $f30c2d593537cf37$var$_typeof(i) ? i : i + "";
}
module.exports = $f30c2d593537cf37$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bnuVp", function(module, exports) {
function $8489d4b837b9f2fc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8489d4b837b9f2fc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8489d4b837b9f2fc$var$_typeof(o);
}
module.exports = $8489d4b837b9f2fc$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8G9Tg", function(module, exports) {

var $bnuVp = parcelRequire("bnuVp");
var $6519eafe6301c989$var$_typeof = $bnuVp.default;
function $6519eafe6301c989$var$toPrimitive(t, r) {
    if ("object" != $6519eafe6301c989$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6519eafe6301c989$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $6519eafe6301c989$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("fyBbG", function(module, exports) {

var $3cw2g = parcelRequire("3cw2g");

var $5LEKe = parcelRequire("5LEKe");

var $1MKv7 = parcelRequire("1MKv7");

var $fRuIt = parcelRequire("fRuIt");
function $b536e0a5cc21cacb$var$_slicedToArray(r, e) {
    return $3cw2g(r) || $5LEKe(r, e) || $1MKv7(r, e) || $fRuIt();
}
module.exports = $b536e0a5cc21cacb$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3cw2g", function(module, exports) {
function $254b57a5d90f0034$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $254b57a5d90f0034$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5LEKe", function(module, exports) {
function $4330f297c94359ec$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $4330f297c94359ec$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1MKv7", function(module, exports) {

var $e1heS = parcelRequire("e1heS");
function $14ce583eb8faab4f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e1heS(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e1heS(r, a) : void 0;
    }
}
module.exports = $14ce583eb8faab4f$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("e1heS", function(module, exports) {
function $a34e87ff24f146e7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $a34e87ff24f146e7$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fRuIt", function(module, exports) {
function $b8c3a1e243797956$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $b8c3a1e243797956$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("g5hub", function(module, exports) {

var $5nIAl = parcelRequire("5nIAl");
function $bb5aad4ad6c4a31e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $5nIAl(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $bb5aad4ad6c4a31e$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5nIAl", function(module, exports) {
function $3eb1af6b98ae69b7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $3eb1af6b98ae69b7$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lF4lh", function(module, exports) {
function $fc50cb93e184d4e5$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $fc50cb93e184d4e5$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4867A", function(module, exports) {

var $kRJF5 = parcelRequire("kRJF5");
function $301ca8601e5145db$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $kRJF5(o.key), o);
    }
}
function $301ca8601e5145db$var$_createClass(e, r, t) {
    return r && $301ca8601e5145db$var$_defineProperties(e.prototype, r), t && $301ca8601e5145db$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $301ca8601e5145db$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("a9qSP", function(module, exports) {

var $8uQ8B = parcelRequire("8uQ8B");
function $763f9922f4a872fc$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $8uQ8B(t, e);
}
module.exports = $763f9922f4a872fc$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8uQ8B", function(module, exports) {
function $62f9918cca87e584$var$_setPrototypeOf(t, e) {
    return module.exports = $62f9918cca87e584$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $62f9918cca87e584$var$_setPrototypeOf(t, e);
}
module.exports = $62f9918cca87e584$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3kSK9", function(module, exports) {

var $3OVzC = parcelRequire("3OVzC");

var $6IaaT = parcelRequire("6IaaT");

var $e1pWy = parcelRequire("e1pWy");
function $26ddb442b62c58ce$var$_createSuper(t) {
    var r = $6IaaT();
    return function() {
        var e, o = $3OVzC(t);
        if (r) {
            var s = $3OVzC(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $e1pWy(this, e);
    };
}
module.exports = $26ddb442b62c58ce$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3OVzC", function(module, exports) {
function $2c82b381e49a34ab$var$_getPrototypeOf(t) {
    return module.exports = $2c82b381e49a34ab$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2c82b381e49a34ab$var$_getPrototypeOf(t);
}
module.exports = $2c82b381e49a34ab$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6IaaT", function(module, exports) {
function $4e2ebe9d6e8816cb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $4e2ebe9d6e8816cb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $4e2ebe9d6e8816cb$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e1pWy", function(module, exports) {

var $bnuVp = parcelRequire("bnuVp");
var $a355487b71aaed22$var$_typeof = $bnuVp.default;

var $gEoGp = parcelRequire("gEoGp");
function $a355487b71aaed22$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $a355487b71aaed22$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $gEoGp(t);
}
module.exports = $a355487b71aaed22$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gEoGp", function(module, exports) {
function $c1f38752f24948d6$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $c1f38752f24948d6$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("2DbVd", function(module, exports) {

var $fqcfw = parcelRequire("fqcfw");

var $1jB5M = parcelRequire("1jB5M");

var $1MKv7 = parcelRequire("1MKv7");

var $jBEyR = parcelRequire("jBEyR");
function $1ea878bc6bd16b6e$var$_toConsumableArray(r) {
    return $fqcfw(r) || $1jB5M(r) || $1MKv7(r) || $jBEyR();
}
module.exports = $1ea878bc6bd16b6e$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fqcfw", function(module, exports) {

var $e1heS = parcelRequire("e1heS");
function $b3a2c92b9173459c$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e1heS(r);
}
module.exports = $b3a2c92b9173459c$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1jB5M", function(module, exports) {
function $0f54568c5235e96a$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $0f54568c5235e96a$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jBEyR", function(module, exports) {
function $e460efa6c4ed86a3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $e460efa6c4ed86a3$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9lyXk", function(module, exports) {
function $6ce130b6c9f9856f$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $6ce130b6c9f9856f$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



//# sourceMappingURL=ProgramPortalContainer.2807015d.js.map
